<div class="animated fadeInDown DocumentContainer" *ngIf="showReceptionVisualizer">

  <div class="PopUpTitleContainer">
    <p class="SectionTitle" style="margin-top: 0%;" *ngIf="this.CurrentReception.ID == null && !DocumentBodyLoading;">
      <span *ngIf="!IsStorno;">{{ 'Receptions.NewReception' | translate }}</span>
      <span *ngIf="IsStorno;">{{ 'Receptions.StornoReception' | translate }}</span>
      </p>
      <p class="SectionTitle" style="margin-top: 0%;" *ngIf="this.CurrentReception.ID != null && !DocumentBodyLoading;">
        <span>
          {{CurrentReception.AccountingNumber.AccountingSeries.Series}} 
          {{(CurrentReception.AccountingNumber.Number)}} 
          / {{CurrentReception.EventRegisterUI}}
        </span>
      </p>
   </div> 

   <div class="PopUpCommands" style="margin-left: 2.5%;box-shadow: 0 4px 3px -2px rgb(0 0 0 / 30%);width: 95%;">
    <button mat-raised-button color="primary" class="VizualizeCommandButton" (click)="ExportReception(this.CurrentReception);" style="outline: none;">
      <i class="material-icons">file_copy</i>
      <span>{{ 'Receptions.Document.Export' | translate }}</span>
    </button>

    <button mat-raised-button class="VizualizeCommandButton" (click)="PrintReception(this.CurrentReception);" style="outline: none;">
      <i class="material-icons">print</i>
      <span>{{ 'Receptions.Document.Print' | translate }}</span>
    </button>

    <button mat-raised-button color="primary" class="BackCommandButton" style="outline: none;float: right; background: #32aa3a;" (click)="this.parent.RedirectToURL('dashboard/documents/receptions');">
      <i class="material-icons">keyboard_double_arrow_left</i>
      <span>{{ 'Receptions.BackToReceptionsMenu' | translate }}</span>
    </button>

    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" (click)="AutoPrintDocument(CurrentReception);" mat-raised-button class="VizualizeCommandButton" matTooltip="{{ 'AutoPrintDesc' | translate }}" matTooltipClass='neutral-tool-tip' style="outline: none;float: right;">
      <i class="material-icons">print</i>
      <span>{{ 'AutoPrint' | translate }}</span>
    </button>

    <mat-progress-bar mode="query" class="DocumentProgressBar" *ngIf="DocumentBodyLoading"></mat-progress-bar>
  </div>

   <div class="PopUpBody" style="max-height: 75vh;" *ngIf="!CurrentReception.IsStorno">
     <div class="DocumentBody">

      <p class="DocumentBodyCanceled" *ngIf="CurrentReception.DocumentStatus.ID == -1;">anulata</p>

       <div style="border: solid 1px #333;">
        
        <table style="width: 100%;margin-bottom: 20px;border-bottom: solid 1px #333;margin-top: 20px;">
          <tbody>
            <tr style="width: 100%;font-weight: 600;font-size: 16px;text-align: center;">
              <td>{{ 'Receptions.Document.Title' | translate }}</td>
            </tr>

            <table style="width: 100%;margin-top: 25px;">
              <tbody>
                <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;">
                  <td>{{ 'Receptions.Document.Unity' | translate }}: {{this.parent.Company.Name}}</td>
                </tr>
                <tr style="width: 30%;text-align: left;float: left;">
                  <td>{{ 'Receptions.Document.DocNr' | translate }}:  {{CurrentReception.AccountingNumber.AccountingSeries.Series}}{{(CurrentReception.AccountingNumber.Number)}}</td>
                </tr>
              </tbody>
            </table>

            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;margin-bottom: 20px;">
                  <td>{{ 'Receptions.Document.Administrations' | translate }}: 
                    <span *ngFor="let a of this.CurrentReception.Administrations; let i=index;">{{a.Name}}; </span>
                  </td>
                </tr>
                <tr style="width: 30%;text-align: left;float: left;">
                  <td>{{ 'Receptions.Document.Date' | translate }}: {{CurrentReception.EventRegisterUI}}</td>
                </tr>
              </tbody>
            </table>
           
          </tbody>
        </table>

        <table style="width: 100%;border-bottom: solid 1px #333;">
          <tbody>
            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.UndersignedTitle' | translate }} {{this.CurrentReception.Supplier.Name}}
                  </td>
                </tr>
              </tbody>
            </table>

            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.SupplyingDocuments' | translate }}: {{this.CurrentReception.DocumentNumber}}
                  </td>
                </tr>
              </tbody>
            </table>

            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.Delegate' | translate }}: {{this.CurrentReception.Details.Delegate}}
                  </td>
                </tr>
              </tbody>
            </table>

            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.Observations' | translate }}: {{this.CurrentReception.Details.Observations}}
                  </td>
                </tr>
              </tbody>
            </table>
            
            <table style="width: 100%;margin-top: 5px;margin-bottom: 20px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.Auto' | translate }}: {{this.CurrentReception.Details.Auto}}
                  </td>
                </tr>
              </tbody>
            </table>

          </tbody>
        </table>

        <table style="width: 100%;">
          <tbody>
            
            <table style="width: 100%;font-size: 12px;">
              <tbody>
                <tr style="width: 100%;">

                  <td style="width: 50%;float: left;padding: 0;">
                    <table style="width: 100%;">
                    <tbody>
                      <tr>
                        <td style="height: 70px;text-align: center;width: 10%;padding: 0;">{{ 'Receptions.Document.Table.Nr' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 60%;padding: 0;">{{ 'Receptions.Document.Table.Name' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 10%;padding: 0;">{{ 'Receptions.Document.Table.MU' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 20%;padding-left: 10px;padding-right: 10px;padding: 5;">{{ 'Receptions.Document.Table.DocQuantity' | translate }}</td>
                      </tr>
                    </tbody>
                    </table>
                  </td>

                  <td style="width: 50%;float: left;padding: 0;">
                    <table style="width: 100%;">
                    <tbody>

                      <tr>
                      <td style="padding: 0;">
                        <table style="width: 100%;height: 35px;border-bottom: solid 1px #333;">
                          <tbody>
                            <tr>
                              <td style="width: 100%;text-align: center;padding: 0;border-left: solid 1px #333;">{{ 'Receptions.Document.Table.Received' | translate }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      </tr>

                      <tr>
                        <td style="padding: 0;">
                          <table style="width: 100%;height: 35px;padding: 0;">
                            <tbody>
                              <tr>
                                <td style="text-align: center;width: 15%;padding: 0;">{{ 'Receptions.Document.Table.Quantity' | translate }}</td>
                                <td style="text-align: center;width: 30%;padding: 0;">{{ 'Receptions.Document.Table.UnitPrice' | translate }} ({{CurrentReception.Currency.Name}})</td>
                                <td style="text-align: center;width: 30%;padding: 0;">{{ 'Receptions.Document.Table.TotalValue' | translate }} ({{CurrentReception.Currency.Name}})</td>
                                <td style="text-align: center;width: 25%;padding: 0;">{{ 'Receptions.Document.Table.VATValue' | translate }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        </tr>

                    </tbody>
                    </table>
                  </td>

                </tr>

                <tr style="width: 100%;">

                 <td style="padding: 0;">
                  <table style="width: 100%;">
                    <tbody>
                      <tr style="width: 100%;height: 20px;line-height: 20px;border-top: solid 1px #ddd;" *ngFor="let p of this.CurrentReception.Products; let i=index;">
                        <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{i + 1}}
                        </td>
            
                        <td style="width: 30%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          ({{p.ProductReceptionInfo.Code}}) {{p.ProductReceptionInfo.Name}}
                        </td>
            
                        <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.MeasuringUnit.Name}}
                        </td>
            
                        <td style="width: 10%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.DocQuantity}}
                        </td>
            
                        <td style="width: 7.5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Quantity}}
                        </td>
            
                        <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Price.UIUnitPrice}}
                        </td>
            
                        <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Price.UIQtyPrice}}
                        </td>
            
                        <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          {{p.ProductReceptionInfo.Price.TotalVATValue}}
                        </td>
                      </tr>
                    </tbody>
                    </table>
                 </td>

                </tr>

                <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                          
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          {{ 'VATPercentages' | translate }}:
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.Table.TotalNOVAT' | translate }}:
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.Table.VATValue' | translate }}:
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          {{ 'Receptions.Document.Table.Total' | translate }}:
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          <span *ngFor="let vat of CurrentReception.VATs">{{vat?.Percentage}}%; </span>
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                          {{CurrentReception.Total.TotalQtyPriceNOVAT}} {{CurrentReception.Currency.Name}}
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                          {{CurrentReception.Total.TotalVAT}} {{CurrentReception.Currency.Name}}
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;font-weight: bold;">
                          {{CurrentReception.Total.TotalQtyPriceVAT}} {{CurrentReception.Currency.Name}}
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.ReceptionCommitee' | translate }}: {{CurrentReception.Details.ReceptionCommittee}}
                         </td>
             
                         <td style="width: 60%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.ReceivedInAdministration' | translate }}:
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 35%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.FullName' | translate }}:
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: left;padding: 0;padding-right: 5px;">
                          {{ 'Receptions.Document.Signature' | translate }}
                         </td>
             
                         <td style="width: 32.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                          {{ 'Receptions.Document.FullName' | translate }}:
                         </td>
             
                         <td style="width: 27.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.Signature' | translate }}
                         </td>
                        
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 50px;text-align: left;padding: 0;padding-left: 5px;">
                           
                         </td>
             
                         <td style="width: 60%;height: 50px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                          {{CurrentReception.UpdatingUser.UserName}}
                         </td>
                        
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.Currency' | translate }}: {{CurrentReception.Details.CurrencyRow}}
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

              </tbody>
            </table>

          </tbody>
        </table>

       </div>

     </div>
   </div>

   <div class="PopUpBody" style="max-height: 75vh;" *ngIf="CurrentReception.IsStorno">
    <div class="DocumentBody">

     <p class="DocumentBodyCanceled" *ngIf="CurrentReception.DocumentStatus.ID == -1;">anulata</p>

      <div style="border: solid 1px #333;">
        <table style="width: 100%;margin-bottom: 20px;border-bottom: solid 1px #333;margin-top: 20px;">
          <tbody>
            <tr style="width: 100%;font-weight: 600;font-size: 16px;text-align: center;">
              <td>{{ 'Receptions.Document.DocumentStorno.ReturnTitle' | translate }}</td>
            </tr>

            <table style="width: 100%;margin-top: 25px;">
              <tbody>
                <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;">
                  <td>{{ 'Receptions.Document.Unity' | translate }}: {{this.parent.Company.Name}}</td>
                </tr>
                <tr style="width: 30%;text-align: left;float: left;">
                  <td>{{ 'Receptions.Document.DocNr' | translate }}:  {{CurrentReception.AccountingNumber.AccountingSeries.Series}}{{(CurrentReception.AccountingNumber.Number)}}</td>
                </tr>
              </tbody>
            </table>

            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;margin-bottom: 20px;">
                  <td>{{ 'Receptions.Document.Administrations' | translate }}: 
                    <span *ngFor="let a of this.CurrentReception.Administrations; let i=index;">{{a.Name}}; </span>
                  </td>
                </tr>
                <tr style="width: 30%;text-align: left;float: left;">
                  <td>{{ 'Receptions.Document.Date' | translate }}: {{CurrentReception.EventRegisterUI}}</td>
                </tr>
              </tbody>
            </table>
           
          </tbody>
        </table>

        <table style="width: 100%;border-bottom: solid 1px #333;">

          <tbody>
            <table style="width: 100%;margin-top: 5px;margin-bottom: 25px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.DocumentStorno.ReturnSubTitle' | translate }} {{this.CurrentReception.Supplier.Name}} 
                    {{ 'Receptions.Document.DocumentStorno.OnDocumentBasis' | translate }} {{CurrentReception.DocumentNumber}} / {{CurrentReception.DocumentDate}}
                  </td>
                </tr>
              </tbody>
            </table>
          </tbody>

        </table>

        <table style="width: 100%;">
          <tbody>
            
            <table style="width: 100%;font-size: 12px;">
              <tbody>
                <tr style="width: 100%;">

                  <td style="width: 50%;float: left;padding: 0;">
                    <table style="width: 100%;">
                    <tbody>
                      <tr>
                        <td style="height: 70px;text-align: center;width: 10%;padding: 0;">{{ 'Receptions.Document.Table.Nr' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 60%;padding: 0;">{{ 'Receptions.Document.Table.Name' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 10%;padding: 0;">{{ 'Receptions.Document.Table.MU' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 20%;padding-left: 10px;padding-right: 10px;padding: 5;">{{ 'Receptions.Document.Table.DocQuantity' | translate }}</td>
                      </tr>
                    </tbody>
                    </table>
                  </td>

                  <td style="width: 50%;float: left;padding: 0;">
                    <table style="width: 100%;">
                    <tbody>

                      <tr>
                      <td style="padding: 0;">
                        <table style="width: 100%;height: 35px;border-bottom: solid 1px #333;">
                          <tbody>
                            <tr>
                              <td style="width: 100%;text-align: center;padding: 0;border-left: solid 1px #333;">{{ 'Receptions.Document.Table.Returned' | translate }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      </tr>

                      <tr>
                        <td style="padding: 0;">
                          <table style="width: 100%;height: 35px;padding: 0;">
                            <tbody>
                              <tr>
                                <td style="text-align: center;width: 15%;padding: 0;">{{ 'Receptions.Document.Table.Quantity' | translate }}</td>
                                <td style="text-align: center;width: 30%;padding: 0;">{{ 'Receptions.Document.Table.UnitPrice' | translate }} ({{CurrentReception.Currency.Name}})</td>
                                <td style="text-align: center;width: 30%;padding: 0;">{{ 'Receptions.Document.Table.TotalValue' | translate }} ({{CurrentReception.Currency.Name}})</td>
                                <td style="text-align: center;width: 25%;padding: 0;">{{ 'Receptions.Document.Table.VATValue' | translate }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        </tr>

                    </tbody>
                    </table>
                  </td>

                </tr>

                <tr style="width: 100%;">

                 <td style="padding: 0;">
                  <table style="width: 100%;">
                    <tbody>
                      <tr style="width: 100%;height: 20px;line-height: 20px;border-top: solid 1px #ddd;" *ngFor="let p of this.CurrentReception.Products; let i=index;">
                        <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{i + 1}}
                        </td>
            
                        <td style="width: 30%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          ({{p.ProductReceptionInfo.Code}}) {{p.ProductReceptionInfo.Name}}
                        </td>
            
                        <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.MeasuringUnit.Name}}
                        </td>
            
                        <td style="width: 10%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.DocQuantity}}
                        </td>
            
                        <td style="width: 7.5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Quantity}}
                        </td>
            
                        <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Price.UIUnitPrice}}
                        </td>
            
                        <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Price.UIQtyPrice}}
                        </td>
            
                        <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          {{p.ProductReceptionInfo.TotalVATValue}}
                        </td>
                      </tr>
                    </tbody>
                    </table>
                 </td>

                </tr>

                <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                          
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.Table.TotalNOVAT' | translate }}:
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.Table.VATValue' | translate }}:
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          {{ 'Receptions.Document.Table.Total' | translate }}:
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                          {{CurrentReception.Total.TotalQtyPriceNOVAT}} {{CurrentReception.Currency.Name}}
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                          {{CurrentReception.Total.TotalVAT}} {{CurrentReception.Currency.Name}}
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;font-weight: bold;">
                          {{CurrentReception.Total.TotalQtyPriceVAT}} {{CurrentReception.Currency.Name}}
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.ReceptionCommitee' | translate }}: {{CurrentReception.Details.ReceptionCommittee}}
                         </td>
             
                         <td style="width: 60%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.ReceivedInAdministration' | translate }}:
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 35%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.FullName' | translate }}:
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: left;padding: 0;padding-right: 5px;">
                          {{ 'Receptions.Document.Signature' | translate }}
                         </td>
             
                         <td style="width: 32.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                          {{ 'Receptions.Document.FullName' | translate }}:
                         </td>
             
                         <td style="width: 27.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.Signature' | translate }}
                         </td>
                        
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 50px;text-align: left;padding: 0;padding-left: 5px;">
                           
                         </td>
             
                         <td style="width: 60%;height: 50px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                          {{CurrentReception.UpdatingUser.UserName}}
                         </td>
                        
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.Currency' | translate }}: {{CurrentReception.Details.CurrencyRow}}
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

              </tbody>
            </table>

          </tbody>
        </table>
      </div>

    </div>
  </div>
</div>

<div class="MainContainer animated fadeIn">

  <div class="InfoQuestion animated fadeInDown" *ngIf="showAccountingSeriesError">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="this.parent.RedirectToURL('/dashboard/settings/mycompany');">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'Configuration.AccountingSeriesDocumentError' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.AccountingSeriesDocumentErrorDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button mat-raised-button color="primary" class="InfoQuestionButton" (click)="this.parent.RedirectToURL('/dashboard/settings/mycompany');"> {{ 'Configuration.GoToSettings' | translate }}</button>
    </div>
  </div>

    <div class="overlay" *ngIf="ShowNoDocumentNumberError || ShowDetectedPaymentsContainer || ShowShippingDetailsContainer || ShowDeleteBoxQuestion || ShowSuggestedPaymentModifier || ShowSuggestionPaymentsContainer || ShowPaymentContainer || DeleteFileQuestion || ShowDocumentError || ShowProductTaxDivisionContainer || showProductDiscountContainer || showAddNewPartnerPopUp || showEditPartnerPopUp || ShowReceptionEditProductContainer || this.parent.loading  || this.parent.initialLoad || showDocumentDiscountContainer || showReceptionVisualizer;"></div>
    <div class="overlay" *ngIf="showAccountingSeriesError;" (click)="this.parent.RedirectToURL('/dashboard/settings/mycompany');"></div>

    <div style="left: 15%;width:80%;" class="CashCollectionContainer animated fadeInDown" *ngIf="ShowDetectedPaymentsContainer">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowDetectedPaymentsContainer = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'ReceptionDetectedPaymentsTitle' | translate }}
      </div>
      <div class="InfoQuestionBody" style="padding-right: 0;">
        {{ 'ReceptionDetectedPaymentsDescription' | translate }}

        <div class="PopUpTitleContainer" style="height: auto;padding-left: 0;padding-right: 0;">
          <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;width: 95%;margin-top: 15px;">
            <div class="ReceptionProductsCol" style="width: 5%;">
              Doc.
            </div>
            <div class="ReceptionProductsCol" style="width: 15%;">
              {{ 'Supplier' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
              {{ 'PaymentDate' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
              {{ 'Value' | translate }} 
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
              {{ 'PaymentType' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 5%;">
                {{ 'Currency' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 5%;">
                {{ 'Receptions.ExchangeRate' | translate }}
              </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
              {{ 'Receptions.DecimalPercision' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 20%;">
                {{ 'CollectionExternalID' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
                {{ 'Actions' | translate }}
            </div>
          </div>
         </div>
      
         <div class="PopUpBody" style="margin-top: 5px;">
      
        <div class="ReceptionProductsContainer  top-box">
      
            <div class="ReceptionProductsRow TotalRow" *ngIf="loading">
                <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
            </div>
      
            <div *ngIf="!loading">
                <div class="ReceptionProductsRow" *ngFor="let c of this.DetectedPayments; let i=index;" [ngClass]="{'UnAssociatedPayment': c.Status.ID == -1, 'AssociatedPayment': c.Status.ID == 1, 'DupplicateCC': c.IsDuplicate == true }">
                    <div class="ReceptionProductsCol" style="width: 5%;">
                     <span *ngIf="c.Status.ID == 1;">{{c.DisplayValue}}</span>
                     <span *ngIf="c.Status.ID == -1;">---</span>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 15%;">
                        <span *ngIf="c.Status.ID == 1;">{{c.Supplier.Name}}</span>
                        <span *ngIf="c.Status.ID == -1;">[ {{c.Status.Name}} ]</span>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                      {{c.PaymentDateUI}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                      {{c.Value}} 
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                      {{c.Type.Name}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 5%;">
                        {{c.Currency.Name}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 5%;">
                        <span *ngIf="c.Currency.ExchangeRate > 0;">{{c.Currency.ExchangeRate}}</span>
                        <span *ngIf="c.Currency.ExchangeRate == 0;">---</span>
                      </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                        {{c.Currency.DecimalPrecision.ID}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 20%;">
                        {{c.PaymentExternalID}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                        <i class="material-icons ReceptionProductEdit" (click)="OpenSuggestedPaymentModifier(c); ShowSuggestedPaymentModifier = true;">edit</i>
                        <i class="material-icons ReceptionProductEdit" style="color: red;" (click)="DeleteDetectedPayment(c);">close</i>
                    </div>
                </div>
            </div>
      
          
        </div>
        
         </div>
      
         <div class="PopUpCommands" style="height: auto;min-height: 50px;padding-bottom: 15px;">
            <div *ngIf="this.SuggestedPayments != null && this.SuggestedPayments.length > 0 && !loading;">
                <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngFor="let Total of this.PaymentTotals; let i=index;">
                    <div class="ReceptionProductsCol" style="width: 5%;">
                         
                    </div>
                    <div class="ReceptionProductsCol" style="width: 15%;">
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
                        {{this.SuggestedPayments.length}} {{'Payments' | translate}}
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                        Total:
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                      <p>{{Total.UITotalQtyPriceVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalQtyPriceVAT.Decimals}}</span></p>
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                        {{Total.Currency.Name}}
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                        
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                        
                    </div>
                    <div class="ReceptionProductsCol" style="width: 20%;">
                      
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                        
                    </div>
                </div>
            </div>
        </div>
      </div>
    
      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDetectedPaymentsContainer = false;">{{ 'Close' | translate }}</button>
        <button [disabled]="this.parent.loading" color="primary" mat-raised-button class="InfoQuestionButton" (click)="ShowDetectedPaymentsContainer = false;AcceptDetectedPayments();">{{ 'AllocatePayments' | translate }}</button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowNoDocumentNumberError">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowNoDocumentNumberError = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'ShowNoDocumentNumberErrorTitle' | translate }}
      </div>
      <div class="InfoQuestionBody">
        <p>{{ 'ShowNoDocumentNumberErrorDescription' | translate }}</p>

        <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
          <mat-label>{{ 'Receptions.DocNumber' | translate }}*</mat-label>
          <input style="letter-spacing: 1px; color: #f60; font-weight: 500!important;" matInput placeholder="Doc Number*" autocomplete="off" [(ngModel)]="CurrentReception.DocumentNumber" (change)="MatchUnallocatedUIT(this.partner, CurrentReception.DocumentNumber); GetDocumentDupplication(this.partner, CurrentReception.DocumentNumber, CurrentReception.ID);CheckUnAllocatedPaymentsByDocumentNumber(CurrentReception.DocumentNumber); MatchUnallocatedUIT(this.partner, CurrentReception.DocumentNumber);">
        </mat-form-field>
      </div>
    
      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowNoDocumentNumberError = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button *ngIf="CurrentReception.ID == null;" [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowNoDocumentNumberError = false; ForceReception = true; AddReception();">{{ 'Receptions.SaveReception' | translate }}</button>
        <button *ngIf="CurrentReception.ID != null;" [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowNoDocumentNumberError = false; ForceReception = true; UpdateReception();">{{ 'Receptions.SaveReception' | translate }}</button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteBoxQuestion">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowDeleteBoxQuestion = false; CurrentBox = null;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.DeleteQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>
    
      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteBoxQuestion = false; CurrentBox = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteBoxQuestion = false;DeleteBox(CurrentBox.UIID);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>
    
    <div class="ShippingDetailsContainer animated fadeInDown" *ngIf="ShowShippingDetailsContainer == true;">
      <div class="ShippingDetailsContainerCloseIcon">
        <i class="material-icons" (click)="ShowShippingDetailsContainer = false;">close</i>
      </div>
    
      <div class="ShippingDetailsContainerTitle">{{'ShippingDetails' | translate}}</div>
    
      <div class="ShippingDetailsContainerBody">
    
        <p class="ShippingDetailsContainerBodyTitle">
          {{'GeneralShippingInformation' | translate}}
          <img *ngIf="this.CurrentReception.Details.ShippingDetails?.ShippingCompany?.ImagePath?.length > 0;" [src]="this.parent.BackendServiceUrl + this.CurrentReception.Details.ShippingDetails.ShippingCompany.ImagePath" class="ShippingDetailsContainerShippingCompanyImage" />
        </p>
    
        <mat-form-field style="width: 100%;" appearance="outline">
          <mat-label>{{ 'ShippingServiceType' | translate }}</mat-label>
          <mat-select name="ShippingServiceType" [compareWith]="compareFn" [(ngModel)]="this.CurrentReception.Details.ShippingDetails.ShippingServiceType">
            <mat-option *ngFor="let s of this.ShippingServiceTypes" [value]="s">
              {{s.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
    
        <mat-form-field style="width: 100%;" appearance="outline">
          <mat-label>{{ 'ShippingWay' | translate }}</mat-label>
          <mat-select name="ShippingWay" [compareWith]="compareFn" [(ngModel)]="this.CurrentReception.Details.ShippingDetails.ShippingWay">
            <mat-option *ngFor="let s of this.ShippingWays" [value]="s">
              {{s.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
    
        <mat-form-field style="width: 100%;" appearance="outline">
          <mat-label>{{ 'ShippingResponsability' | translate }}</mat-label>
          <mat-select name="ShippingResponsability" [compareWith]="compareFn" [(ngModel)]="this.CurrentReception.Details.ShippingDetails.ShippingResponsability">
            <mat-option *ngFor="let s of this.ShippingResponsabilities" [value]="s">
              {{s.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
    
        <mat-form-field style="width: 100%;" appearance="outline">
          <mat-label>{{ 'ShippingCompany' | translate }}</mat-label>
          <mat-select name="ShippingCompany" [compareWith]="compareFn" [(ngModel)]="this.CurrentReception.Details.ShippingDetails.ShippingCompany">
            <mat-option *ngFor="let s of this.ShippingCompanies" [value]="s">
              {{s.Name}}
              <img *ngIf="s.ImagePath?.length > 0;" [src]="this.parent.BackendServiceUrl + s.ImagePath" class="ShippingDetailsContainerShippingCompanyImage" />
            </mat-option>
          </mat-select>
        </mat-form-field>
    
        <mat-form-field style="width: 100%;" appearance="outline">
          <mat-label>{{ 'WeightType' | translate }}</mat-label>
          <mat-select name="WeightType" [compareWith]="compareFn" [(ngModel)]="this.CurrentReception.Details.ShippingDetails.WeightType">
            <mat-option *ngFor="let t of this.WeightTypes" [value]="t">
              {{t.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
    
        <p class="ShippingDetailsContainerBodyTitle">{{'TransportedBoxesInformation' | translate}}</p>
    
        <button mat-raised-button color="primary" (click)="AddNewBox();" style="margin-bottom: 10px;">{{'AddNewParcel' | translate}}</button>
    
        <div class="ParcelContainerHeadder" *ngIf="this.CurrentReception?.Details?.ShippingDetails?.Boxes?.length > 0;">
    
          <div class="ParcelIndexHeadder">
              <span>#</span>
          </div>
    
          <div class="ParcelDimentionHeadder">
            <span>{{ 'Length' | translate }}</span>
          </div>
    
          <i class="material-icons BetweenDimentionsX">close</i>
    
          <div class="ParcelDimentionHeadder">
            <span>{{ 'Width' | translate }}</span>
          </div>
    
          <i class="material-icons BetweenDimentionsX">close</i>
    
          <div class="ParcelDimentionHeadder">
            <span>{{ 'Height' | translate }}</span>
          </div>
    
          <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
    
          <div class="ParcelDimentionHeadder">
            <span>{{ 'Weight' | translate }}</span>
          </div>
    
          <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
    
          <div class="ParcelDimentionHeadder">
            <span>{{ 'WeightType' | translate }}</span>
          </div>
    
          <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
    
          <div class="ParcelDimentionHeadder" style="width: auto; max-width: 220px;">
            <span>{{ 'TrackingLabel' | translate }}</span>
          </div>
    
        </div>
    
        <div class="ParcelContainer" *ngFor="let box of this.CurrentReception.Details.ShippingDetails.Boxes; let j=index;" style="border-bottom: solid 1px #ddd;">
          <div class="ParcelIndex">
           <span *ngIf="box.IsPallet != true;">{{'Parcel' | translate}}</span>
           <span *ngIf="box.IsPallet == true;">{{'Pallet' | translate}}</span>
           <span>#{{j + 1}}</span>
          </div>
          
          <mat-form-field appearance="outline" class="ParcelDimention">
            <mat-label>{{ 'Length' | translate }}*</mat-label>
            <input matInput placeholder="{{'Length' | translate}}" autocomplete="off" [(ngModel)]="box.Length" (click)="$event.target.select()">
          </mat-form-field>
    
          <i class="material-icons BetweenDimentionsX">close</i>
    
          <mat-form-field appearance="outline" class="ParcelDimention">
            <mat-label>{{ 'Width' | translate }}*</mat-label>
            <input matInput placeholder="{{'Width' | translate}}" autocomplete="off" [(ngModel)]="box.Width" (click)="$event.target.select()">
          </mat-form-field>
    
          <i class="material-icons BetweenDimentionsX">close</i>
    
          <mat-form-field appearance="outline" class="ParcelDimention">
            <mat-label>{{ 'Height' | translate }}*</mat-label>
            <input matInput placeholder="{{'Height' | translate}}" autocomplete="off" [(ngModel)]="box.Height" (click)="$event.target.select()">
          </mat-form-field>
    
          <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
    
          <mat-form-field appearance="outline" class="ParcelDimention">
            <mat-label>{{this.CurrentInvoice?.Details?.ShippingDetails?.WeightType?.Name}}*</mat-label>
            <input matInput placeholder="{{'Weight' | translate}}" autocomplete="off" [(ngModel)]="box.Weight" (click)="$event.target.select()">
          </mat-form-field>
    
          <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
    
          <mat-checkbox class="PalletCheckBox" [(ngModel)]="box.IsPallet">{{'Pallet' | translate}}?</mat-checkbox>
    
          <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
    
          <mat-form-field appearance="outline" class="BoxTrackingLabel">
            <mat-label>{{ 'TrackingLabel' | translate }}</mat-label>
            <input matInput placeholder="{{'TrackingLabel' | translate}}" autocomplete="off" [(ngModel)]="box.TrackingLabel">
          </mat-form-field>
    
          <div class="boxStatus" *ngIf="box.ID > 0;">
            <i class="material-icons">check</i>
          </div>
    
          <div class="boxStatus">
            <i class="material-icons" style="color: red;cursor: pointer;" (click)="CurrentBox = box; ShowDeleteBoxQuestion = true;">close</i>
          </div>
        </div>
    
      </div>
      <div class="ShippingDetailsContainerCommands">
        <button *ngIf="this.CurrentReception.Details.ShippingDetails?.ID > 0;" mat-raised-button color="warn" style="float:left;" (click)="ShowDeleteShippingDetailsContainer = true;" matTooltipClass='neutral-tool-tip'>
          <i class="material-icons ">delete_forever</i>
        </button>
        <button mat-raised-button color="primary" style="float:right;" (click)="ShowShippingDetailsContainer = false;" matTooltip="{{ 'NoSavingAtDBLevelWarning' | translate }}" matTooltipClass='neutral-tool-tip'>OK</button>
        <button mat-raised-button color="accent" style="float:right;margin-right: 10px;" (click)="ProofShippingDetails(this.CurrentReception.Details.ShippingDetails, true);" matTooltip="{{ 'SaveToDBDescription' | translate }}" matTooltipClass='neutral-tool-tip'>{{'SaveToDB' | translate}}</button>
      </div>
    </div>

    <div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowSuggestionPaymentsContainer" style="left: 16%;width: 83%;">
      <div class="PopUpCloseContainer" (click)="ShowSuggestionPaymentsContainer = false;">
        <i class="material-icons">close</i>
      </div>
    
      <div class="PopUpTitleContainer" style="height: auto;padding-left: 0;padding-right: 0;">
        <p>{{ 'DetectedPayments' | translate }}</p>
    
        <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;width: 95%;margin-left: 2.5%;margin-top: 15px;">
          <div class="ReceptionProductsCol" style="width: 5%;">
            {{ 'Document' | translate }}
          </div>
          <div class="ReceptionProductsCol" style="width: 15%;">
            {{ 'Supplier' | translate }}
          </div>
          <div class="ReceptionProductsCol" style="width: 10%;">
            {{ 'PaymentDate' | translate }}
          </div>
          <div class="ReceptionProductsCol" style="width: 10%;">
            {{ 'Value' | translate }} 
          </div>
          <div class="ReceptionProductsCol" style="width: 10%;">
            {{ 'PaymentType' | translate }}
          </div>
          <div class="ReceptionProductsCol" style="width: 5%;">
              {{ 'Currency' | translate }}
          </div>
          <div class="ReceptionProductsCol" style="width: 5%;">
              {{ 'Receptions.ExchangeRate' | translate }}
            </div>
          <div class="ReceptionProductsCol" style="width: 10%;">
            {{ 'Receptions.DecimalPercision' | translate }}
          </div>
          <div class="ReceptionProductsCol" style="width: 20%;">
              {{ 'CollectionExternalID' | translate }}
          </div>
          <div class="ReceptionProductsCol" style="width: 10%;">
              {{ 'Actions' | translate }}
          </div>
        </div>
       </div>
    
       <div class="PopUpBody" style="margin-top: 5px;">
    
      <div class="ReceptionProductsContainer  top-box">
    
          <div class="ReceptionProductsRow TotalRow" *ngIf="loading">
              <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
          </div>
    
          <div *ngIf="!loading">
              <div class="ReceptionProductsRow" *ngFor="let c of this.CurrentReception.Details.Payments; let i=index;" [ngClass]="{'UnAssociatedPayment': c.Status.ID == -1, 'AssociatedPayment': c.Status.ID == 1, 'DupplicateCC': c.IsDuplicate == true }">
                  <div class="ReceptionProductsCol" style="width: 5%;">
                   <span *ngIf="c.Status.ID == 1;">{{c.DisplayValue}}</span>
                   <span *ngIf="c.Status.ID == -1;">---</span>
                  </div>
                  <div class="ReceptionProductsCol" style="width: 15%;">
                      <span *ngIf="c.Status.ID == 1;">{{c.Supplier.Name}}</span>
                      <span *ngIf="c.Status.ID == -1;">[ {{c.Status.Name}} ]</span>
                  </div>
                  <div class="ReceptionProductsCol" style="width: 10%;">
                    {{c.PaymentDateUI}}
                  </div>
                  <div class="ReceptionProductsCol" style="width: 10%;">
                    {{c.Value}} 
                  </div>
                  <div class="ReceptionProductsCol" style="width: 10%;">
                    {{c.Type.Name}}
                  </div>
                  <div class="ReceptionProductsCol" style="width: 5%;">
                      {{c.Currency.Name}}
                  </div>
                  <div class="ReceptionProductsCol" style="width: 5%;">
                      <span *ngIf="c.Currency.ExchangeRate > 0;">{{c.Currency.ExchangeRate}}</span>
                      <span *ngIf="c.Currency.ExchangeRate == 0;">---</span>
                    </div>
                  <div class="ReceptionProductsCol" style="width: 10%;">
                      {{c.Currency.DecimalPrecision.ID}}
                  </div>
                  <div class="ReceptionProductsCol" style="width: 20%;">
                      {{c.PaymentExternalID}}
                  </div>
                  <div class="ReceptionProductsCol" style="width: 10%;" *ngIf="c.ID != 0;">
                      <i class="material-icons ReceptionProductEdit" (click)="OpenSuggestedPaymentModifier(c); ShowSuggestedPaymentModifier = true;">edit</i>
                      <i class="material-icons ReceptionProductEdit" style="color: red;" (click)="ClonePayment(c); ShowDeleteSpendingQuestion = true;">close</i>
                  </div>

                  <div class="ReceptionProductsCol" style="width: 10%;" *ngIf="c.ID == 0;">
                    <i class="material-icons ReceptionProductEdit" style="color: red;" (click)="DeleteNewPaymentOnNewReception(c);">close</i>
                </div>
              </div>
          </div>
    
        
      </div>
      
       </div>
    
       <div class="PopUpCommands" style="height: auto;min-height: 50px;padding-bottom: 15px;">
          <div *ngIf="this.SuggestedPayments != null && this.SuggestedPayments.length > 0 && !loading;">
              <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngFor="let Total of this.PaymentTotals; let i=index;">
                  <div class="ReceptionProductsCol" style="width: 5%;">
                       
                  </div>
                  <div class="ReceptionProductsCol" style="width: 15%;">
                  </div>
                  <div class="ReceptionProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
                      {{this.SuggestedPayments.length}} {{'Payments' | translate}}
                  </div>
                  <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                      Total:
                  </div>
                  <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                    <p>{{Total.UITotalQtyPriceVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalQtyPriceVAT.Decimals}}</span></p>
                  </div>
                  <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                      {{Total.Currency.Name}}
                  </div>
                  <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                      
                  </div>
                  <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                      
                  </div>
                  <div class="ReceptionProductsCol" style="width: 20%;">
                    
                  </div>
                  <div class="ReceptionProductsCol" style="width: 10%;">
                      
                  </div>
              </div>
          </div>
      </div>
    </div>

    <div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowPaymentContainer">
      <div class="PopUpCloseContainer" (click)="ShowPaymentContainer = false;">
        <i class="material-icons">close</i>
      </div>
    
      <div class="PopUpTitleContainer">
        <p *ngIf="this.currentPayment.ID > 0;">{{ 'UpdatePayment' | translate }}</p>
        <p *ngIf="!this.currentPayment.ID > 0;">{{ 'NewPayment' | translate }}</p>
       </div>
    
       <div class="PopUpBody" style="margin-top: 20px;">
    
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'PaymentType' | translate }}</mat-label>
              <mat-select name="PaymentType" [(ngModel)]="currentPayment.Type" [compareWith]="compareFn">
                <mat-option *ngFor="let type of this.PaymentTypes;" [value]="type">
                  {{type.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
    
            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'Currency' | translate }}</mat-label>
              <mat-select name="Currency" [(ngModel)]="currentPayment.Currency" [compareWith]="compareFn">
                <mat-option *ngFor="let c of this.Currencies;" [value]="c" (click)="ReselectBankAccount(c);">
                  {{c.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
    
            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'AccountNumber' | translate }}</mat-label>
              <mat-select name="AccountNumber" [(ngModel)]="currentPayment.BankAccount" [compareWith]="compareFn">
                <mat-option *ngFor="let b of this.BankAccounts;" [value]="b">
                  {{b.DisplayValue}}
                </mat-option>
              </mat-select>
            </mat-form-field>
    
            <mat-form-field appearance="outline" style="width: 100%;padding: 0;" *ngIf="this.currentPayment.Currency.ExchangeRate > 0;">
              <mat-label>{{ 'Receptions.ExchangeRate' | translate }}</mat-label>
              <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.Currency.ExchangeRate">
              <mat-icon matSuffix>calculate</mat-icon>
            </mat-form-field>
    
            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'Receptions.DecimalPercision' | translate }}</mat-label>
              <mat-select name="DecimalPercision" [(ngModel)]="currentPayment.Currency.DecimalPrecision" [compareWith]="compareFn">
                <mat-option *ngFor="let d of this.DecimalPrecisions;" [value]="d">
                  {{d.Meaning}}
                </mat-option>
              </mat-select>
            </mat-form-field>
    
        <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
          <mat-label>{{ 'PaymentDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="dp3" [formControl]="CollectionDate" [(ngModel)]="currentPayment.PaymentDate">
          <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
          <mat-datepicker #dp3></mat-datepicker>
        </mat-form-field>
    
        <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
          <mat-label>{{ 'PaymentValue' | translate }}* [{{this.currentPayment.Currency.Name}}]</mat-label>
          <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.Value" style="color: #32aa3a;" (change)="VerifyPriceModel(this.currentPayment.Value);">
          <mat-icon matSuffix>monetization_on</mat-icon>
        </mat-form-field>
    
        <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
          <mat-label>{{ 'PaymentExternalID' | translate }}</mat-label>
          <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.PaymentExternalID">
          <mat-icon matSuffix>qr_code_2</mat-icon>
        </mat-form-field>
    
          <p class="CashCollectRemainingInfo" *ngIf="this.PaymentRemainingValue >= 0;">{{'RemainingToPay' | translate}}: {{this.PaymentRemainingValue}} {{this.currentPayment.Currency.Name}}</p>
          <p class="CashCollectRemainingInfo" *ngIf="this.PaymentRemainingValue < 0;">{{'OverPayed' | translate}}: {{this.PaymentRemainingValue}} {{this.currentPayment.Currency.Name}}</p>
       </div>
    
       <div class="PopUpCommands" *ngIf="this.CurrentReception.ID != null;">
          <button *ngIf="!this.currentPayment.ID > 0;" [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Cash Collection" class="PopGeneralCommandButton" (click)="AddPayment();ShowPaymentContainer = false;">
            <span>{{'AddPayment' | translate}}</span>
          </button>
      </div>
      <div class="PopUpCommands" *ngIf="this.CurrentReception.ID == null;">
        <button *ngIf="!this.currentPayment.ID > 0;" [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Cash Collection" class="PopGeneralCommandButton" (click)="AddPaymentOnNewReception();ShowPaymentContainer = false;">
          <span>{{'AddPayment' | translate}}</span>
        </button>
    </div>
    </div>

    <div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowSuggestedPaymentModifier">
      <div class="PopUpCloseContainer" (click)="ShowSuggestedPaymentModifier = false;">
        <i class="material-icons">close</i>
      </div>
    
      <div class="PopUpTitleContainer">
        <p *ngIf="this.currentPayment.ID > 0;">{{ 'UpdatePayment' | translate }}</p>
        <p *ngIf="!this.currentPayment.ID > 0;">{{ 'NewPayment' | translate }}</p>
       </div>
    
       <div class="PopUpBody" style="margin-top: 20px;">
          
          <div class="currentPaymentRadioGroupContainer">
              <mat-radio-group
              [(ngModel)]="currentPayment.Category">
              <mat-radio-button class="example-radio-button" *ngFor="let c of this.PaymentCategories" [value]="c">
                {{c.Name}}
              </mat-radio-button>
            </mat-radio-group>
          </div>
    
          <div *ngIf="this.currentPayment.Category.ID == 0;">
              <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                  <mat-label>{{ 'AssociatedReception' | translate }}*</mat-label>
                  <input *ngIf="!this.currentPayment.ReceptionID.length > 0;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.DisplayValue" (click)="SearchReceptions(this.currentPayment.DisplayValue);" (keyup)="SearchReceptions(this.currentPayment.DisplayValue);">
                  <input disabled="disabled" *ngIf="this.currentPayment.ReceptionID.length > 0;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.DisplayValue">
                  <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="this.currentPayment.ReceptionID.length > 0;" (click)="this.currentPayment.ReceptionID = '';this.currentPayment.DisplayValue = '';this.currentPayment.ReceptionDetailsID = null">close</mat-icon>
                  <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="!this.currentPayment.ReceptionID.length > 0 && SearchedReceptions != null;" (click)="this.currentPayment.DisplayValue = ''; SearchedReceptions = null">close</mat-icon>
              </mat-form-field>
    
              <div class="InvoiceSearchContainer" *ngIf="SearchedReceptions != null;">
                  <div class="InvoiceSearchResult" *ngFor="let r of this.SearchedReceptions; let j=index;" (click)="SelectReceptionForPaymentSearch(r);">
                     <div class="InvoiceSearchResultCol">
                      {{r.AccountingNumber.DisplayValue}}
                     </div>
                     <div class="InvoiceSearchResultCol" style="width: 40%;">
                      {{r.Supplier.Name}}
                     </div>
                     <div class="InvoiceSearchResultCol">
                      {{r.EventRegisterUIDate}}
                     </div>
                     <div class="InvoiceSearchResultCol">
                      {{r.Total.TotalQtyPriceVAT}} {{r.Currency.Name}}
                     </div>
                  </div>
              </div>
          </div>
    
          <div *ngIf="this.currentPayment.Category.ID == 1;">
              <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                  <mat-label>{{ 'AssociatedSpending' | translate }}*</mat-label>
                  <input *ngIf="this.currentPayment.SpendingID == null;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.DisplayValue" (click)="SearchSpendings(this.currentPayment.DisplayValue);" (keyup)="SearchSpendings(this.currentPayment.DisplayValue);">
                  <input disabled="disabled" *ngIf="this.currentPayment.SpendingID != null;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.DisplayValue">
                  <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="this.currentPayment.SpendingID != null;" (click)="this.currentPayment.SpendingID = null;this.currentPayment.DisplayValue = '';this.currentPayment.ReceptionDetailsID = null">close</mat-icon>
                  <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="!this.currentPayment.SpendingID != null && Spendings != null;" (click)="this.currentPayment.DisplayValue = '';this.currentPayment.SpendingID = null;">close</mat-icon>
              </mat-form-field>
    
              <div class="InvoiceSearchContainer" *ngIf="Spendings != null;">
                  <div class="InvoiceSearchResult" *ngFor="let s of this.Spendings; let j=index;" (click)="SelectSpendingForPaymentSearch(s);">
                     <div class="InvoiceSearchResultCol" style="width: 60%;">
                      {{s.Partner.Name}}
                     </div>
                     <div class="InvoiceSearchResultCol">
                      {{s.DocumentDateUI}}
                     </div>
                     <div class="InvoiceSearchResultCol">
                      {{s.Total.TotalQtyPriceVAT}} {{s.Currency.Name}}
                     </div>
                  </div>
              </div>
          </div>
    
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'PaymentType' | translate }}</mat-label>
              <mat-select name="PaymentType" [(ngModel)]="currentPayment.Type" [compareWith]="compareFn">
                <mat-option *ngFor="let type of this.PaymentTypes;" [value]="type">
                  {{type.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
    
            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'Currency' | translate }}</mat-label>
              <mat-select name="Currency" [(ngModel)]="currentPayment.Currency" [compareWith]="compareFn">
                <mat-option *ngFor="let c of this.Currencies;" [value]="c" (click)="ReselectBankAccount(c);">
                  {{c.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
    
            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'AccountNumber' | translate }}</mat-label>
              <mat-select name="AccountNumber" [(ngModel)]="currentPayment.BankAccount" [compareWith]="compareFn">
                <mat-option *ngFor="let b of this.BankAccounts;" [value]="b">
                  {{b.DisplayValue}}
                </mat-option>
              </mat-select>
            </mat-form-field>
    
            <mat-form-field appearance="outline" style="width: 100%;padding: 0;" *ngIf="this.currentPayment.Currency.ExchangeRate > 0;">
              <mat-label>{{ 'Receptions.ExchangeRate' | translate }}</mat-label>
              <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.Currency.ExchangeRate">
              <mat-icon matSuffix>calculate</mat-icon>
            </mat-form-field>
    
            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'Receptions.DecimalPercision' | translate }}</mat-label>
              <mat-select name="DecimalPercision" [(ngModel)]="currentPayment.Currency.DecimalPrecision" [compareWith]="compareFn">
                <mat-option *ngFor="let d of this.DecimalPrecisions;" [value]="d">
                  {{d.Meaning}}
                </mat-option>
              </mat-select>
            </mat-form-field>
    
        <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
          <mat-label>{{ 'PaymentDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="dp3" [formControl]="CollectionDate" [(ngModel)]="currentPayment.PaymentDate">
          <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
          <mat-datepicker #dp3></mat-datepicker>
        </mat-form-field>
    
        <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
          <mat-label>{{ 'PaymentValue' | translate }}* [{{this.currentPayment.Currency.Name}}]</mat-label>
          <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.Value" (change)="VerifyPriceModel(this.currentPayment.Value);">
          <mat-icon matSuffix>monetization_on</mat-icon>
        </mat-form-field>
    
        <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
          <mat-label>{{ 'PaymentExternalID' | translate }}</mat-label>
          <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.PaymentExternalID">
          <mat-icon matSuffix>qr_code_2</mat-icon>
        </mat-form-field>
       </div>
    
       <div class="PopUpCommands">
        <button [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Cash Collection" class="PopGeneralCommandButton" (click)="ShowSuggestedPaymentModifier = false;UpdatePayment(this.currentPayment);">
            <span>{{'UpdatePayment' | translate}}</span>
      </button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteSpendingQuestion">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowDeleteSpendingQuestion = false; currentSpending = null;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.DeleteQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>

      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteSpendingQuestion = false; currentPayment = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteSpendingQuestion = false;DeletePayment(currentPayment.ID);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>

    <div class="animated fadeInDown ReceptionEditProductContainer" *ngIf="ShowProductTaxDivisionContainer">
      <div class="PopUpCloseContainer" (click)="ShowProductTaxDivisionContainer = false;">
        <i class="material-icons">close</i>
      </div>
      <div class="ReceptionEditProductTitleContainer">
       <p>{{ 'Receptions.ConsumeTax' | translate }} - {{this.CurrentProduct.ProductReceptionInfo.Name}}</p>
      </div>

      <div class="PopUpBody">
        <div class="PopUpBodyRow" style="min-height: 50px;padding-top: 10px;padding-left: 1%;">
          <mat-radio-group (change)="RadioChangeTaxDivisionType($event)" aria-labelledby="example-radio-group-label" class="example-radio-group">
            <mat-radio-button [checked]="type.ID === this.CurrentProduct.ProductReceptionInfo.GeneralType.TaxDivisionType.ID" [value]="type" class="LangRadio" *ngFor="let type of this.TaxDivisionTypes; index as i">{{type.Name}}</mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="PopUpBodyRow" style="min-height: 50px;padding-top: 10px;padding-left: 1%;">
          {{this.CurrentProduct.ProductReceptionInfo.Name}} ({{this.CurrentProduct.ProductReceptionInfo.Code}})
        </div>

        <div class="PopUpBodyRow" *ngIf="IsLoadingTaxDivision">
          <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
        </div>
        
        <div *ngIf="!IsLoadingTaxDivision">
          <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;">
            <div class="ReceptionProductsCol">
                {{ 'Receptions.Table.Nr' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
                {{ 'Receptions.Administration' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
                {{ 'Receptions.Table.Name' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
                {{ 'Receptions.Table.Code' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
                {{ 'Receptions.Table.MU' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
                {{ 'Receptions.Table.Qty' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
                {{ 'Receptions.Table.DocQty' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 20%;">
              Procent repartizare
            </div>
            <div class="ReceptionProductsCol" style="width: 15%;">
              Valoare repartizata
            </div>
        </div>
  
          <div class="ReceptionProductsRow ReceptionProductsRowHover" *ngFor="let p of this.Products; let i=index;">
          <div *ngIf="p.ProductReceptionInfo.GeneralType.ID == 1;">
            <div class="ReceptionProductsCol">
              {{i + 1}}
          </div>
          <div class="ReceptionProductsCol" style="width: 10%;">
              {{p.ProductReceptionInfo.Administration.Name}}
          </div>
          <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
            <p>{{p.ProductReceptionInfo.Name}}</p>
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
            {{p.ProductReceptionInfo.Code}}
            <p class="ReceptionProductsColDesc">{{p.ProductReceptionInfo.GeneralType.Name}}</p>
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
            {{p.ProductReceptionInfo.MeasuringUnit.Name}}
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
            {{p.ProductReceptionInfo.Quantity}}
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
            {{p.ProductReceptionInfo.DocQuantity}}
          </div>
          <div class="ReceptionProductsCol" style="width: 20%;">
            {{p.ProductReceptionInfo.TaxDistribution.Percentage}}%
          </div>
            <div class="ReceptionProductsCol" style="width: 15%;">
              {{p.ProductReceptionInfo.TaxDistribution.QtyValue}}
            </div>
            </div>
          </div>
        </div>

      </div>

      <div class="PopUpCommands">
        <button mat-raised-button color="primary" class="ReceptionEditProductSaveButton" (click)="SubmitTaxProductDistribution();">
          <i class="material-icons">read_more</i>
          {{ 'Receptions.ConsumeTax' | translate }}
        </button>
        <button mat-raised-button color="warn" class="ReceptionEditProductSaveButton" (click)="CancelTaxProductDistribution();" *ngIf="this.CurrentProduct.ProductReceptionInfo.GeneralType.IsTaxConsumed == true;">
          <i class="material-icons">close</i>
          {{ 'Receptions.CancelTaxDistribution' | translate }}
        </button>
      </div>

    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="DeleteFileQuestion">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="DeleteFileQuestion = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.DeleteQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>

      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="DeleteFileQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="DeleteFileQuestion = false;DeleteFile(this.CurrentReception.ID);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>

    <div class="animated fadeInDown ReceptionEditProductContainer" *ngIf="ShowReceptionEditProductContainer">
      <div class="PopUpCloseContainer" (click)="ShowReceptionEditProductContainer = false;RevertProduct();">
        <i class="material-icons">close</i>
      </div>
      <div class="ReceptionEditProductTitleContainer">
       <p>
        <i class="material-icons titleModificationIcon">build</i>
         {{CurrentProduct.ProductReceptionInfo.Name}}
        </p>
      </div>

      <div class="PopUpBody" *ngIf="!loadingEditProduct">
        <div class="PopUpBodyRowContainer" *ngIf="CurrentProduct.ID == null;">
          <div class="PopUpBodyTwoThirdsContainer">
            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'Receptions.Administration' | translate }}</mat-label>
              <mat-select name="Administration" [compareWith]="compareFirst" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Administration">
                <mat-option *ngFor="let a of this.Administrations;" [value]="a">
                  {{a.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="PopUpBodyOneThirddContainer">
            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'HOME.ProductType' | translate }}</mat-label>
              <mat-select name="vats" [compareWith]="compareFirst" [(ngModel)]="CurrentProduct.ProductReceptionInfo.GeneralType">
                <mat-option *ngFor="let t of this.ProductGeneralTypes" [value]="t" (onSelectionChange)="chanveNewProductVALUE($event);">
                  {{t.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        </div>

        <div class="PopUpBodyRowContainer" *ngIf="CurrentProduct.ID != null;">
          <div class="PopUpBodyTwoThirdsContainer">
            <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
              <mat-label>{{ 'Receptions.Administration' | translate }}</mat-label>
              <input disabled="disabled" matInput placeholder="{{ 'Receptions.Administration' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Administration.Name">
            </mat-form-field>
          </div>

          <div class="PopUpBodyOneThirddContainer">
            <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
              <mat-label>{{ 'HOME.ProductType' | translate }}</mat-label>
              <input disabled="disabled" matInput placeholder="{{ 'HOME.ProductType' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductReceptionInfo.GeneralType.Name">
            </mat-form-field>
          </div>

        </div>
       
        <div class="PopUpBodyRowContainer">
          <div class="PopUpBodyTwoThirdsContainer">
            <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
              <mat-label>{{ 'Receptions.Table.Name' | translate }}</mat-label>
              <input matInput placeholder="{{ 'Receptions.Table.Name' | translate }}" autocomplete="off" (click)="SearchProductsReceptionInformation(CurrentProduct.ProductReceptionInfo.Name, CurrentProduct.ProductReceptionInfo.Administration.ID, true); showhideSearches(true);" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Name" (ngModelChange)="chanveNewProductVALUE($event); SearchProductsReceptionInformation(CurrentProduct.ProductReceptionInfo.Name, CurrentProduct.ProductReceptionInfo.Administration.ID, true);">
              <mat-icon matSuffix style="cursor: pointer;" *ngIf="ProductsSearchResultsCOUNTPop == 0 && !loadingSearchProducts && CurrentProduct.ProductReceptionInfo.Name.length == 0;">search</mat-icon>
              <mat-icon matSuffix style="cursor: pointer;" *ngIf="(ProductsSearchResultsCOUNTPop > 0 || CurrentProduct.ProductReceptionInfo.Name.length > 0) && !loadingSearchProducts;" (click)="DestroySearchedProducts();">close</mat-icon>
            </mat-form-field>
            <div class="SpinnerIconContainer" *ngIf="loadingSearchProducts">
              <mat-spinner class="smallSpinner" [diameter]="25"></mat-spinner>
            </div>
          </div>
          <div class="PopUpBodyOneThirddContainer">
            <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
              <mat-label>{{ 'Receptions.Table.Code' | translate }}</mat-label>
              <input disabled *ngIf="CurrentProduct.ProductReceptionInfo.ProductID != null;" matInput placeholder="{{ 'Receptions.Table.Code' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Code">
              <input *ngIf="CurrentProduct.ProductReceptionInfo.ProductID == null;" matInput placeholder="{{ 'Receptions.Table.Code' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Code">
            </mat-form-field>
          </div>
          <div class="ProductsSearchResultsContainer ProductsSearchResultsContainerPopException" *ngIf="ProductsSearchResultsCOUNTPop > 0 && this.showSearchCurrent == true;">
            <div class="ProductSearchResult" *ngFor="let p of ProductsSearchResultsPop" (click)="SelectReceptionProductFromSearchCurrent(p);">
                <p class="ProductSearchResultTitle">{{p.Name}}</p>
            </div>
          </div>
        </div>

        <div class="PopUpBodyRowContainer">
          <div class="PopUpBodyOneThirddContainer">
            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'Receptions.Table.MU' | translate }}</mat-label>
              <mat-select name="MeasuringUnit" [compareWith]="compareFirst" [(ngModel)]="CurrentProduct.ProductReceptionInfo.MeasuringUnit">
                <mat-option *ngFor="let u of this.MeasuringUnits" [value]="u">
                  {{u.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="PopUpBodyOneThirddContainer">
            <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
              <mat-label>{{ 'Receptions.Table.Qty' | translate }}</mat-label>
              <input matInput placeholder="{{ 'Receptions.Table.Qty' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Quantity">
            </mat-form-field>
          </div>
          <div class="PopUpBodyOneThirddContainer">
            <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
              <mat-label>{{ 'Receptions.Table.DocQty' | translate }}</mat-label>
              <input matInput placeholder="{{ 'Receptions.Table.DocQty' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductReceptionInfo.DocQuantity">
            </mat-form-field>
          </div>
        </div>

        <div class="PopUpBodyRowContainer">
          <div class="PopUpBodyOneThirddContainer">
            <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
              <mat-label>{{ 'Receptions.Table.PriceNOVAT' | translate }}</mat-label>
              <input [disabled]="CurrentProduct.ProductReceptionInfo.PriceContainsVAT" matInput placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Price.UIUnitPrice"  (change)="VerifyPriceModel(CurrentProduct.ProductReceptionInfo.Price.UIUnitPrice);">
            </mat-form-field>
          </div>

           <div class="PopUpBodyOneThirddContainer">
            <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
              <mat-label>{{ 'Receptions.Table.PriceVAT' | translate }}</mat-label>
              <input [disabled]="!CurrentProduct.ProductReceptionInfo.PriceContainsVAT" matInput placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Price.UIVATUnitPrice"  (change)="VerifyPriceModel(CurrentProduct.ProductReceptionInfo.Price.UIVATUnitPrice);">
            </mat-form-field>
          </div>

          <div class="PopUpBodyOneThirddContainer">
            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'Receptions.Table.VAT' | translate }}</mat-label>
              <mat-select name="vats" [compareWith]="compareFirst" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Price.VAT">
                <mat-option *ngFor="let v of this.VATRates" [value]="v" (click)="ModifyReceptionProduct(true);">
                  {{v.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        
        </div>

        <div class="PopUpBodyRowContainer">
          <div class="PopUpBodyOneThirddContainer">
            <mat-slide-toggle (change)="priceContainsVATchanged($event)" [(ngModel)]="CurrentProduct.ProductReceptionInfo.PriceContainsVAT">{{ 'Receptions.Table.PriceContainsVAT' | translate }}</mat-slide-toggle>
          </div>
        </div>

        <div class="DiscountRow" *ngIf="CurrentProduct.ProductReceptionInfo.Price.Discount != null && CurrentProduct.ProductReceptionInfo.Price.Discount.Value != null && CurrentReception.Total.Discount.Value == null;">

          <p class="DiscountRowTitle">
            {{CurrentProduct.ProductReceptionInfo.Price.Discount.Type.Name}} Discount - {{CurrentProduct.ProductReceptionInfo.Price.Discount.Value}}
            <span *ngIf="CurrentProduct.ProductReceptionInfo.Price.Discount.Type.ID == 1;">%</span>
            <span> ({{currency.Name}})</span>
          </p>

          <div class="PopUpBodyOneThirddContainer">
            <mat-form-field class="ReceptionProductsColSearch">
              <mat-label>{{ 'Receptions.Table.PriceNOVAT' | translate }}</mat-label>
              <input [disabled]="true" matInput placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Price.UIUnitPriceDiscount">
            </mat-form-field>
          </div>

           <div class="PopUpBodyOneThirddContainer">
            <mat-form-field class="ReceptionProductsColSearch">
              <mat-label>{{ 'Receptions.Table.PriceVAT' | translate }}</mat-label>
              <input [disabled]="true" matInput placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Price.UIVATUnitPriceDiscount">
            </mat-form-field>
          </div>

            <div class="PopUpBodyRowContainer">
             <button mat-button color="warn" (click)="EliminateProductDiscount();">
              <i class="material-icons buttonIcon">close</i>
              {{ 'Receptions.EliminateDiscount' | translate }}
             </button>
            </div>
        </div>

      </div>

      <div class="PopUpBody" *ngIf="loadingEditProduct">
        <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
      </div>

      <div class="PopUpCommands">
        <button mat-raised-button color="primary" class="ReceptionEditProductSaveButton" (click)="ModifyReceptionProduct();">
          <i class="material-icons buttonIcon">check</i>
          {{'ModifyProduct' | translate}}
        </button>
      </div>
    </div>

    <div class="animated fadeInDown DiscountContainer" *ngIf="showProductDiscountContainer">
      <div class="PopUpCloseContainer" (click)="showProductDiscountContainer = false;">
        <i class="material-icons">close</i>
      </div>
    
      <div class="PopUpTitleContainer">
        <p>{{ 'Receptions.MenuDiscount' | translate }}</p>
       </div>

       <div class="PopUpBody" style="margin-bottom: 0px;padding-top: 10px;">

        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
          <mat-label>{{ 'Receptions.DiscountType' | translate }}</mat-label>
          <mat-select name="discounts" [compareWith]="compareFn" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Price.Discount.Type">
            <mat-option *ngFor="let d of this.DiscountTypes" [value]="d" (onSelectionChange)="chanveNewProductVALUE($event);">
              {{d.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- <mat-radio-group (change)="RadioChangeDiscountType($event)" aria-labelledby="example-radio-group-label" class="example-radio-group" [(ngModel)]="this.CurrentProduct.ProductReceptionInfo.Price.Discount.Type">
          <mat-radio-button [checked]="d.Name === this.CurrentProduct.ProductReceptionInfo.Price.Discount.Type.Name" [value]="d" class="LangRadio" *ngFor="let d of this.DiscountTypes; index as i">{{d.Name}}</mat-radio-button>
        </mat-radio-group> -->

        <mat-form-field class="example-full-width discountTextBox" appearance="outline">
          <mat-label>{{ 'Receptions.DiscountValue' | translate }}</mat-label>
          <i style="border: none;" class="material-icons PartnerEditIcon">edit</i>
          <input autocomplete="off" [(ngModel)]="CurrentProduct.ProductReceptionInfo.Price.Discount.Value" matInput placeholder="{{ 'Receptions.DiscountValue' | translate }}">
        </mat-form-field>

      </div>

       <div class="PopUpCommands">
        <button (click)="ApplyDiscount();" [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="{{ 'Receptions.ApplyDiscount' | translate }}" class="PopGeneralCommandButton">{{ 'Receptions.ApplyDiscount' | translate }}</button>
      </div>
    </div>

    <div class="animated fadeInDown DiscountContainer" *ngIf="showDocumentDiscountContainer">
      <div class="PopUpCloseContainer" (click)="showDocumentDiscountContainer = false;">
        <i class="material-icons">close</i>
      </div>
    
      <div class="PopUpTitleContainer">
        <p>{{ 'Receptions.DocDiscount' | translate }}</p>
       </div>

       <div class="PopUpBody" style="margin-bottom: 0px;padding-top: 10px;">

        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
          <mat-label>{{ 'Receptions.DiscountType' | translate }}</mat-label>
          <mat-select name="discounts" [compareWith]="compareFn" [(ngModel)]="CurrentReception.Total.Discount.Type">
            <mat-option *ngFor="let d of this.DiscountTypes" [value]="d">
              {{d.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="example-full-width discountTextBox" appearance="outline">
          <mat-label>{{ 'Receptions.DiscountValue' | translate }}</mat-label>
          <i style="border: none;" class="material-icons PartnerEditIcon">edit</i>
          <input autocomplete="off" [(ngModel)]="CurrentReception.Total.Discount.Value" matInput placeholder="{{ 'Receptions.DiscountValue' | translate }}">
        </mat-form-field>

      </div>

       <div class="PopUpCommands">
        <button (click)="ApplyReceptionDiscount();" [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="{{ 'Receptions.ApplyDiscount' | translate }}" class="PopGeneralCommandButton">{{ 'Receptions.ApplyDiscount' | translate }}</button>
      </div>
    </div>

    <div *ngIf="showAddNewPartnerPopUp" class="animated fadeInDown NewPartnerPopUp">
        <div class="PopUpCloseContainer" (click)="showAddNewPartnerPopUp = false;">
          <i class="material-icons">close</i>
        </div>
        <div class="PopUpTitleContainer">
         <p>{{ 'Partners.AddNewPartner' | translate }}</p>
        </div>
  
        <div class="PopUpBody">
  
          <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.General' | translate }}</p>
  
          <form [formGroup]="newPartner">
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.VAT' | translate }}</mat-label>
              <input matInput placeholder="ex. RO1234567" value="" autocomplete="off" formControlName="VAT">
              <i class="material-icons CheckEUVATButton" (click)="GetPartnerEUData(this.newPartner, true);" *ngIf="this.newPartner.controls['VAT'].value != null && this.newPartner.controls['VAT'].value.length && this.newPartner.controls['Country'].value != null;">cloud_download</i>
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.UPN' | translate }}</mat-label>
              <input matInput placeholder="ex. CNP - RO" value="" autocomplete="off" formControlName="UPN">
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.Name' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="Name" required>
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.COCRegNumber' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="COCRegNumber">
            </mat-form-field>
    
            <div class="PopUpBodySemiTextBox">
              <mat-slide-toggle formControlName="TaxPayer">{{ 'Partners.PartnerWindow.TaxPayer' | translate }}</mat-slide-toggle>
            </div>
    
            <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Address' | translate }}</p>
    
            <div class="PopUpBodySemiTextBox">
              <mat-form-field>
                <mat-label>{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</mat-label>
                <mat-select [(ngModel)]="newPartnerCountry" name="country" formControlName="Country" [compareWith]="compareFn" required>
                  <mat-option *ngFor="let c of parent.masterData.Countries" [value]="c">
                    {{c.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.StateProvince' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="StateProvince">
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.City' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="City">
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.AddressLine' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="AddressLine" required>
            </mat-form-field>

            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'ZipCode' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="ZipCode">
            </mat-form-field>
    
            <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Bank' | translate }}:</p>
    
            <div class="PopUpBodySemiTextBox">
              <mat-form-field>
                <mat-label>{{ 'Partners.PartnerWindow.ChooseBank' | translate }}</mat-label>
                <mat-select [(ngModel)]="newPartnerBank" name="bank" formControlName="Bank">
                  <mat-option *ngFor="let b of parent.masterData.Banks" [value]="b">
                    {{b.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox" *ngIf="newPartnerBank != null;">
              <mat-label>{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="BankAccount">
            </mat-form-field>
    
            <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.ContactInfo' | translate }}</p>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Login.Email' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="Email">
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.Name' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="ContactName">
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Login.Phone' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="Phone">
            </mat-form-field>
          </form>
  
        </div>
  
        <div class="PopUpCommands">
          <button [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Partner" class="PopGeneralCommandButton" (click)="AddNewPartner();">{{'Partners.AddNewPartner' | translate}}</button>
        </div>
      </div>

      <div *ngIf="showEditPartnerPopUp" class="animated fadeInDown NewPartnerPopUp">
        <div class="PopUpCloseContainer" (click)="showEditPartnerPopUp = false;">
          <i class="material-icons">close</i>
        </div>
        <div class="PopUpTitleContainer">
         <p>{{ 'Partners.EditPartner' | translate }}</p>
        </div>
  
        <div class="PopUpBody">
  
          <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.General' | translate }}</p>
  
          <form [formGroup]="currentPartner">
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.VAT' | translate }}</mat-label>
              <input matInput placeholder="ex. RO1234567" value="" autocomplete="off" formControlName="VAT">
              <i class="material-icons CheckEUVATButton" (click)="GetPartnerEUData(this.currentPartner, false);" *ngIf="this.currentPartner.controls['VAT'].value != null && this.currentPartner.controls['VAT'].value.length;">cloud_download</i>
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.UPN' | translate }}</mat-label>
              <input matInput placeholder="ex. CNP - RO" value="" autocomplete="off" formControlName="UPN">
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.Name' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="Name" required>
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.COCRegNumber' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="COCRegNumber">
            </mat-form-field>
    
            <div class="PopUpBodySemiTextBox">
              <mat-slide-toggle formControlName="TaxPayer">{{ 'Partners.PartnerWindow.TaxPayer' | translate }}</mat-slide-toggle>
            </div>
    
            <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Address' | translate }}</p>
    
            <div class="PopUpBodySemiTextBox">
              <mat-form-field>
                <mat-label>{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</mat-label>
                <mat-select name="country" [compareWith]="compareFn" formControlName="Country" required>
                  <mat-option *ngFor="let c of parent.masterData.Countries" [value]="c">
                    {{c.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.StateProvince' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="StateProvince" required>
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.City' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="City" required>
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.AddressLine' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="AddressLine" required>
            </mat-form-field>

            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'ZipCode' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="ZipCode">
            </mat-form-field>
    
            <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Bank' | translate }}</p>
    
            <div class="PopUpBodySemiTextBox">
              <mat-form-field>
                <mat-label>{{ 'Partners.PartnerWindow.ChooseBank' | translate }}</mat-label>
                <mat-select name="bank" [compareWith]="compareFn" formControlName="Bank">
                  <mat-option *ngFor="let b of parent.masterData.Banks" [value]="b">
                    {{b.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="BankAccount">
            </mat-form-field>
    
            <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.ContactInfo' | translate }}</p>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Login.Email' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="Email">
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.Name' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="ContactName">
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Login.Phone' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="Phone">
            </mat-form-field>
          </form>
  
        </div>
  
        <div class="PopUpCommands">
          <button [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Partner" class="PopGeneralCommandButton" (click)="UpdatePartner();">{{'UpdatePartner' | translate}}</button>
        </div>
      </div>

      <div class="MainTitleBar" *ngIf="this.CurrentReception.Details?.ForceDocumentClosing == true && this.CurrentReception.Status?.ID == 1;">
        <div class="TopValueBanner"  [ngClass]="{'CollectedStatusPopUp': this.CurrentReception.Status.ID == 1}">
          <div>
            {{CurrentReception.Status.Name}} {{'ForcedDocumentClose' | translate}} 
            <i class="material-icons TopValueBannerIcon">verified</i>
          </div>
        </div>
      </div>

      <div class="MainTitleBar" *ngIf="this.CurrentReception.Details.PaymentRemainingValue != undefined;">
        <div class="TopValueBanner"  [ngClass]="{'CollectedStatusPopUp': this.CurrentReception.Details.PaymentRemainingValue == 0, 'OverduePopUp': this.CurrentReception.Details.PaymentRemainingValue != 0 && this.CurrentReception.Status.ID == 5}">
          
          <div *ngIf="this.CurrentReception.Details.PaymentRemainingValue != 0;">
            {{'RemainingToBePaid' | translate}}: 
            <span class="TopValueBannerValue">{{this.CurrentReception.Details.PaymentRemainingValue}} {{currency.Name}}</span>
            <i *ngIf="this.CurrentReception.Status.ID == 5;" class="material-icons TopValueBannerIcon">money_off_csred</i>
          </div>

          <div *ngIf="this.CurrentReception.Details.PaymentRemainingValue == 0;">
            {{CurrentReception.Status.Name}} 
            <i class="material-icons TopValueBannerIcon">verified</i>
          </div>
        
        </div>
      </div>

      <div class="MainTitleBar" *ngIf="this.CurrentReception.ID?.length > 0;">

        <div class="TopValueBanner" style="background: #efdc75;opacity: 0.75;">
          <span style="color: #f60;">{{'ClosedDocumentModificationWarning' | translate}}</span>
          <i class="material-icons TopValueBannerIcon" style="color: #f60;">lightbulb</i>
        </div>
      </div>

    <div class="MainTitleBar" *ngIf="SavedReception != true;">
        <p class="SectionTitle" style="margin-top: 0%;border-bottom: solid 1px #ddd;" *ngIf="this.CurrentReception.ID == null;">
        <span *ngIf="!IsStorno;">{{ 'Receptions.NewReception' | translate }}</span>
        <span *ngIf="IsStorno;">{{ 'Receptions.StornoReception' | translate }}</span>
        <span class="DocumentMainCurrencyTopValue">{{currency.Name}}</span>
        </p>
        <p class="SectionTitle" style="margin-top: 0%;" *ngIf="this.CurrentReception.ID != null;">
          <span *ngIf="!IsStorno">
            {{ 'Receptions.UpdateReception' | translate }} 
          </span>
          <span *ngIf="IsStorno">
            {{ 'Receptions.ModifyStorno' | translate }} 
          </span>
          <span class="InvoiceDisplayValue">{{this.CurrentReception.AccountingNumber.DisplayValue}}</span>
          <span class="DocumentMainCurrencyTopValue">{{currency.Name}}</span>
        </p>
    </div>

    <div class="MainBody animated fadeIn" *ngIf="this.parent.initialLoad == false && SavedReception != true;">
       
        <div class="NewReceptionBodyRow">
            <div class="PartnerSearchContainer">
                <mat-form-field appearance="outline" style="width: 100%;padding: 0;" (click)="InitializePartnersOnClick(this.searchTerm, this.countryID, true);">
                    <mat-label>{{ 'Receptions.SearchSupplier' | translate }}*</mat-label>
                    <input matInput placeholder="Name/VAT" autocomplete="off" [(ngModel)]="this.searchTerm" (ngModelChange)="this.searchPartnerUpdate.next($event)" (keydown.enter)="this.partner = Partners[0];resultsLength = 0;this.searchTerm='';AdjustCurrencyOnPartnerSeleciton();GetDocumentDupplication(this.partner, CurrentReception.DocumentNumber, CurrentReception.ID);TestDocumentValidity(); MatchUnallocatedUIT(this.partner, CurrentReception.DocumentNumber);">
                    <mat-icon matSuffix (click)="GetPartnersFiltered(this.searchTerm, this.countryID, true);" style="cursor: pointer;">search</mat-icon>
                    <i class="material-icons addNewPartnerButton" *ngIf="!this.searchTerm" (click)="showAddNewPartnerPopUp = true;initializeAddPartnerForm();">person_add</i>
                    <i class="material-icons addNewPartnerButton" style="border:none;color:red;" *ngIf="this.searchTerm" (click)="this.searchTerm=''; this.Partners.length = 0;resultsLength = 0;">close</i>
                  </mat-form-field>
    
                  <div class="PartnerSearchResultsContainer" *ngIf="resultsLength > 0;">
                    <div class="PartnerSearchResult" *ngFor="let p of Partners" (click)="this.partner = p;resultsLength = 0;this.searchTerm='';AdjustCurrencyOnPartnerSeleciton();GetDocumentDupplication(this.partner, CurrentReception.DocumentNumber, CurrentReception.ID);TestDocumentValidity(); MatchUnallocatedUIT(this.partner, CurrentReception.DocumentNumber);">
                        <p class="SearchResultTitle DottedRow">{{p.Name}} <span style="font-weight: bold;" *ngIf="p.VAT?.length;">{{p.VAT}}</span></p>
                    </div>
                  </div>
    
                  <div class="PartnerInfoContainer" *ngIf="partner != null">
                    <i class="material-icons PartnerInfoContainerEUVerified" matTooltip="EU Verified" *ngIf="partner.EUVATVerified">verified_user</i>
                    <p class="PartnerInfoTitle">{{partner.Name }} 
                        <i *ngIf="partner.ID != null;" class="material-icons PartnerDeleteIcon" (click)="partner = null;TestDocumentValidity();">close</i>
                        <i *ngIf="partner.ID != null;" class="material-icons PartnerEditIcon" (click)="initializePartnerFormFromObject(partner);">edit</i>
                        <i *ngIf="partner.ID == null;" class="material-icons PartnerEditIcon" (click)="InsertPartnerFromCloud(partner);">cloud_download</i>
                    </p>
                    <span class="PartnerInfoSubTitle" *ngIf="partner.VAT?.length;">{{partner.VAT}} | </span>
                    <span class="PartnerInfoSubTitle" *ngIf="partner.COCRegNumber?.length;">{{partner.COCRegNumber}}</span>
                    <p class="PartnerInfoSubTitle">{{partner.BillingAddress.Country.ShortName}}, {{partner.BillingAddress.StateProvince}}, {{partner.BillingAddress.City}},| {{partner.BillingAddress.AddressLine}}</p>
                  </div>
            </div>
    
            <div class="newReceptionInputContainer" style="width: 15%;">
                <mat-form-field style="width: 100%;" appearance="outline">
                    <mat-label>{{ 'Receptions.DocumentType' | translate }}</mat-label>
                    <mat-select name="DocType" [compareWith]="compareFn" [(ngModel)]="CurrentReception.DocType">
                      <mat-option *ngFor="let doc of this.DocTypes" [value]="doc">
                        {{doc.Meaning}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field style="width: 100%;" appearance="outline" *ngIf="CurrentReception.AccountingNumber.ID == null;">
                    <mat-label>{{ 'Receptions.Series' | translate }}</mat-label>
                    <mat-select name="Series" [compareWith]="compareFn" [(ngModel)]="CurrentReception.AccountingNumber.AccountingSeries">
                      <mat-option *ngFor="let series of this.AccountingSeries" [value]="series">
                        {{series.Series}} (nr.XXXX)
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline" style="width: 100%;padding: 0;" *ngIf="CurrentReception.AccountingNumber.ID != null;">
                    <mat-label>{{CurrentReception.AccountingNumber.AccountingSeries.Series}} {{(CurrentReception.AccountingNumber.Number)}}</mat-label>
                    <input matInput placeholder="Series" autocomplete="off" disabled="true">
                  </mat-form-field>
            </div>
    
            <div class="newReceptionInputContainer" style="width: 15%;">
                  <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                    <mat-label>{{ 'Receptions.DocNumber' | translate }}*</mat-label>
                    <input style="letter-spacing: 1px; color: #f60; font-weight: 500!important;" matInput placeholder="Doc Number*" autocomplete="off" [(ngModel)]="CurrentReception.DocumentNumber" (change)="GetDocumentDupplication(this.partner, CurrentReception.DocumentNumber, CurrentReception.ID);CheckUnAllocatedPaymentsByDocumentNumber(CurrentReception.DocumentNumber); MatchUnallocatedUIT(this.partner, CurrentReception.DocumentNumber);">
                    <i *ngIf="this.CurrentReception.Details.ETransportDetails?.ETransportUIT?.length" matTooltip="{{'FoundUITForGivenDocument' | translate}} {{this.CurrentReception.Details.ETransportDetails?.ETransportUIT}}" matTooltipClass='neutral-tool-tip' class="material-icons UITFoundIcon">verified</i>
                  </mat-form-field>

                  <div class="DupplicateDocumentAlert" *ngFor="let dupplicate of this.DupplicateDocumentReceptions">
                      {{'DupplicateDocuments' | translate}}: 
                    <span>
                      {{dupplicate.AccountingNumber.DisplayValue}}
                    </span>
                  </div>

                  <div class="DupplicateDocumentAlert" *ngFor="let dupplicate of this.DupplicateDocumentReceptions">
                    {{'InvoiceCreator' | translate}}: 
                    <span>
                      {{dupplicate.CreatingUser.UIName}}
                    </span>
                  </div>

                  <div class="DupplicateDocumentAlert" *ngFor="let dupplicate of this.DupplicateDocumentReceptions">
                    {{'Receptions.DocumentDate' | translate}}: 
                    <span>
                      {{dupplicate.EventRegisterUI}}
                    </span>
                  </div>

                  <div class="DupplicateDocumentAlert" *ngIf="this.DetectedPayments?.length;" style="padding-left:0;">
                    <div class="DetectedPaymentsButton" (click)="OpenDetectedPayments();">
                      <i class="material-icons">notifications_active</i>
                      {{'DetectedPayments' | translate}} [{{this.DetectedPayments?.length}}]
                    </div>
                  </div>
            </div>
    
            <div class="newReceptionInputContainer">
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'Receptions.DocumentDate' | translate }}</mat-label>
                    <input matInput [matDatepicker]="dp" [formControl]="DocumentDate" [(ngModel)]="CurrentReception.DocumentDate" (dateChange)="TestDocumentValidity();">
                    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                    <mat-datepicker #dp></mat-datepicker>
                  </mat-form-field>
    
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'Receptions.DueDate' | translate }}</mat-label>
                    <input matInput [matDatepicker]="dp1" [formControl]="PaymentDueDate" [(ngModel)]="CurrentReception.PaymentDueDate" (dateChange)="TestDocumentValidity();">
                    <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
                    <mat-datepicker #dp1></mat-datepicker>
                  </mat-form-field>
            </div>
    
            <div class="newReceptionInputContainer" style="width: 15%;">
                <mat-form-field style="width: 100%;" appearance="outline">
                    <mat-label>{{ 'Receptions.Currency' | translate }}</mat-label>
                    <mat-select name="currency" [compareWith]="compareFn" [(ngModel)]="currency">
                      <mat-option *ngFor="let c of this.Currencies" [value]="c" (click)="GetCurrencyLiveExchange(c);">
                        {{c.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <div class="ReceptionSelectedCurrency" *ngIf="currency != null && currency.ExchangeRate > 0;">
                    <mat-form-field class="example-full-width ReceptionExchangeInput">
                        <mat-label>{{ 'Receptions.ExchangeRate' | translate }}</mat-label>
                        <i style="border: none;" class="material-icons PartnerEditIcon">edit</i>
                        <input [(ngModel)]="currency.ExchangeRate" matInput placeholder="Exchange">
                      </mat-form-field>
                  </div>
            </div>
        </div>

        <div class="NewReceptionBodyRow">
            <div class="PartnerSearchContainer">
                
            </div>
    
            <div class="newReceptionInputContainer" style="width: 15%;">
              
            </div>
    
            <div class="newReceptionInputContainer" style="width: 15%;">
             
            </div>
    
            <div class="newReceptionInputContainer">
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'Receptions.StockEntryDate' | translate }}</mat-label>
                    <input matInput [matDatepicker]="dp2" [formControl]="StockEntryDate" [(ngModel)]="CurrentReception.StockEntryDate" (dateChange)="TestDocumentValidity();">
                    <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
                    <mat-datepicker #dp2></mat-datepicker>
                  </mat-form-field>
            </div>
    
            <div class="newReceptionInputContainer" style="width: 15%;">
                <mat-form-field style="width: 100%;" appearance="outline">
                    <mat-label>{{ 'Receptions.DecimalPercision' | translate }}</mat-label>
                    <mat-select name="DocType" [compareWith]="compareFn" [(ngModel)]="ReceptionPrecision">
                      <mat-option *ngFor="let p of this.DecimalPrecisions" [value]="p" (onSelectionChange)="chanveNewProductVALUE($event);" (click)="AdjustProductsDecimalPrecisionPrice();">
                        {{p.Meaning}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
            </div>
        </div>

        <div class="ReceptionProductsContainer">
            <div class="ReceptionProductsRow" style="padding-top: 10px;border: none;">
                <div class="ReceptionProductsCol" style="width: 15%;">
                    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" *ngIf="NewProduct.ID == null;">
                        <mat-label>{{ 'Receptions.Administration' | translate }}</mat-label>
                        <mat-select name="Administration" [compareWith]="compareFirst" [(ngModel)]="NewProduct.ProductReceptionInfo.Administration">
                          <mat-option *ngFor="let a of this.Administrations;" [value]="a" (onSelectionChange)="chanveNewProductVALUE($event);" (click)="SearchProductsReceptionInformation(NewProduct.ProductReceptionInfo.Name, a.ID, false);">
                            {{a.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field appearance="outline" class="ReceptionProductsColSearch" *ngIf="NewProduct.ID != null;">
                        <mat-label>{{ 'Receptions.Administration' | translate }}</mat-label>
                        <input disabled="disabled" matInput placeholder="{{ 'Receptions.Administration' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductReceptionInfo.Administration.Name">
                      </mat-form-field>
                </div>
                <div class="ReceptionProductsCol" style="width: 20%;text-align: left;">
                    <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
                        <mat-label>{{ 'Receptions.Table.Name' | translate }}</mat-label>
                        <input (click)="SearchProductsReceptionInformation(NewProduct.ProductReceptionInfo.Name, NewProduct.ProductReceptionInfo.Administration.ID, false); showhideSearches(false);" matInput placeholder="{{ 'Receptions.Table.Name' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductReceptionInfo.Name" (ngModelChange)="chanveNewProductVALUE($event); SearchProductsReceptionInformation(NewProduct.ProductReceptionInfo.Name, NewProduct.ProductReceptionInfo.Administration.ID, false);" (keydown.enter)="SelectReceptionProductFromSearch(ProductsSearchResults[0]);">
                        <mat-icon matSuffix style="cursor: pointer;" *ngIf="ProductsSearchResultsCOUNT == 0 && !loadingSearchProducts && NewProduct.ProductReceptionInfo.Name.length == 0;">search</mat-icon>
                        <mat-icon matSuffix style="cursor: pointer;" *ngIf="(ProductsSearchResultsCOUNT > 0 || NewProduct.ProductReceptionInfo.Name.length > 0) && !loadingSearchProducts;" (click)="DestroySearchedProducts();">close</mat-icon>
                      </mat-form-field>
                      <div class="SpinnerIconContainer" *ngIf="loadingSearchProducts">
                        <mat-spinner class="smallSpinner" [diameter]="25"></mat-spinner>
                      </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
                        <mat-label>{{ 'Receptions.Table.Code' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'Receptions.Table.Code' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductReceptionInfo.Code" (ngModelChange)="chanveNewProductVALUE($event); SearchProductsReceptionInformation(NewProduct.ProductReceptionInfo.Code, NewProduct.ProductReceptionInfo.Administration.ID, false);">
                      </mat-form-field>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                        <mat-label>{{ 'Receptions.Table.MU' | translate }}</mat-label>
                        <mat-select name="Administration" [compareWith]="compareFirst" [(ngModel)]="NewProduct.ProductReceptionInfo.MeasuringUnit">
                          <mat-option *ngFor="let u of this.MeasuringUnits" [value]="u" (selectionChange)="chanveNewProductVALUE($event);">
                            {{u.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
                        <mat-label>{{ 'Receptions.Table.Qty' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'Receptions.Table.Qty' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductReceptionInfo.Quantity" (ngModelChange)="chanveNewProductVALUE($event);MirrorDocQuantity($event);">
                      </mat-form-field>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
                        <mat-label>{{ 'Receptions.Table.DocQty' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'Receptions.Table.DocQty' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductReceptionInfo.DocQuantity" (ngModelChange)="chanveNewProductVALUE($event);">
                      </mat-form-field>
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                    <mat-form-field appearance="outline" class="ReceptionProductsColSearch" *ngIf="!NewProductPriceContainsVAT">
                        <mat-label>{{ 'Receptions.Table.Price' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductReceptionInfo.Price.UIUnitPrice" (ngModelChange)="chanveNewProductVALUE($event);" (change)="VerifyPriceModel(NewProduct.ProductReceptionInfo.Price.UIUnitPrice);">
                      </mat-form-field>

                      <mat-form-field appearance="outline" class="ReceptionProductsColSearch" *ngIf="NewProductPriceContainsVAT">
                        <mat-label>{{ 'Receptions.Table.Price' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductReceptionInfo.Price.UIVATUnitPrice" (ngModelChange)="chanveNewProductVALUE($event);" (change)="VerifyPriceModel(NewProduct.ProductReceptionInfo.Price.UIVATUnitPrice);">
                      </mat-form-field>
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                  <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                    <mat-label>{{ 'Receptions.Table.VAT' | translate }}</mat-label>
                    <mat-select name="vats" [compareWith]="compareFirst" [(ngModel)]="NewProduct.ProductReceptionInfo.Price.VAT">
                      <mat-option *ngFor="let v of this.VATRates" [value]="v" (click)="chanveNewProductVALUE($event);">
                        {{v.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="ReceptionProductsCol" style="width: 15%;">
                  <button [disabled]="!IsValidNewProduct" mat-raised-button color="primary" class="ReceptionProductsAddButton" (click)="AddProductToReception();">
                    <i class="material-icons">add</i>
                    <span>{{ 'Receptions.Table.AddToReception' | translate }}</span>
                </button>
                </div>

                <div class="ProductsSearchResultsContainer" *ngIf="ProductsSearchResultsCOUNT > 0 && this.showSearch;">
                  <div class="ProductSearchResult" *ngFor="let p of ProductsSearchResults" (click)="SelectReceptionProductFromSearch(p);" [ngClass]="{'SearchResultPoolProductAlert': p.IsFromPool}">
                    <p class="ProductSearchResultTitle">{{p.Name}} 
                      <span *ngIf="p.DiscrepancyAmmount != null;" class="DiscrepancyAmmountSpan" [ngClass]="{'MinusDiscrepancyAmmount': p.DiscrepancyAmmount < 0, 'NormalDiscrepancyAmmount': p.DiscrepancyAmmount >= 0}">{{p.DiscrepancyAmmount}}
                        <span *ngIf="p.DiscrepancyAmmount < 0;"> {{'MissingStockValue' | translate}}</span>
                        <span *ngIf="p.DiscrepancyAmmount >= 0;"> {{'StockValue' | translate}}</span>
                      </span>
                    </p>
                    <p class="ProductSearchResultType">[{{p.Code}}] [{{p.GeneralType.Name}}] <span *ngIf="p.IsFromPool;">[{{'PoolProduct' | translate}}]</span></p>
                  </div>
                </div>

            </div>

            <div class="ReceptionProductsRow" style="height: 50px;border: none;">
                <div class="ReceptionProductsCol" style="width: 15%;margin-top: 5px;">
                    <mat-slide-toggle [(ngModel)]="NewProductPriceContainsVAT"(change)="priceContainsVATchanged($event);">{{ 'Receptions.Table.PriceContainsVAT' | translate }}</mat-slide-toggle>
                </div>
                <div class="ReceptionProductsCol" style="width: 15%;text-align: left;padding-left: 1%;">
                  <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" *ngIf="NewProduct.ID == null;">
                    <mat-label>{{ 'HOME.ProductType' | translate }}</mat-label>
                    <mat-select name="vats" [compareWith]="compareFirst" [(ngModel)]="NewProduct.GeneralType">
                      <mat-option *ngFor="let t of this.ProductGeneralTypes" [value]="t" (onSelectionChange)="chanveNewProductVALUE($event);">
                        {{t.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="ReceptionProductsColSearch" *ngIf="NewProduct.ID != null;">
                    <mat-label>{{ 'HOME.ProductType' | translate }}</mat-label>
                    <input disabled="disabled" matInput placeholder="{{ 'HOME.ProductType' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.GeneralType.Name">
                  </mat-form-field>
                </div>
                <div class="ReceptionProductsCol" style="width: 20%;">
                  
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                   
                </div>
                <div class="ReceptionProductsCol">
                   
                </div>
                <div class="ReceptionProductsCol">
                   
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                  
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                   
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                   
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                  
                </div>
            </div>

            <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;">
                <div class="ReceptionProductsCol">
                    {{ 'Receptions.Table.Nr' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                    {{ 'Receptions.Administration' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
                    {{ 'Receptions.Table.Name' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'Receptions.Table.Code' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'Receptions.Table.MU' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'Receptions.Table.Qty' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'Receptions.Table.DocQty' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                    {{ 'Receptions.Table.Price' | translate }}  ({{currency.Name}})
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                    {{ 'Receptions.Table.Total' | translate }} ({{currency.Name}})
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'Receptions.Table.VAT' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                  
                </div>
            </div>

            <div [ngClass]="{'NewProductAlertColor': p.ID == null || p.ID == 0, 'PoolProductAlert': p.IsFromPool}" class="ReceptionProductsRow ReceptionProductsRowHover" *ngFor="let p of this.Products; let i=index;" (dblclick)="OpenReceptionEditProduct(p.ProductReceptionInfo.UIID);CurrentIndexProduct = i;">
              <div class="ReceptionProductsCol">
                  {{i + 1}}
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;">
                  <p>{{p.ProductReceptionInfo.Administration.Name}}</p>
                  <p class="NewProductAlert" *ngIf="p.ID == null || p.ID == 0;">[{{'NewProduct' | translate}}]</p>
                  <p class="PoolProductAlertRow" *ngIf="p.IsFromPool;">[{{'PoolProduct' | translate}}]</p>
              </div>
              <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
                <p>{{p.ProductReceptionInfo.Name}}</p>
              </div>
              <div class="ReceptionProductsCol" style="width: 7.5%;">
                <p>{{p.ProductReceptionInfo.Code}}</p>
                <p class="ReceptionProductsColDesc">{{p.ProductReceptionInfo.GeneralType.Name}}</p>
              </div>
              <div class="ReceptionProductsCol" style="width: 7.5%;">
                {{p.ProductReceptionInfo.MeasuringUnit.Name}}
              </div>
              <div class="ReceptionProductsCol" style="width: 7.5%;">
                {{p.ProductReceptionInfo.Quantity}}
              </div>
              <div class="ReceptionProductsCol" style="width: 7.5%;">
                {{p.ProductReceptionInfo.DocQuantity}}
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;">
                <span *ngIf="p.ProductReceptionInfo.Price.Discount == null || p.ProductReceptionInfo.Price.Discount.Value == null">{{p.ProductReceptionInfo.Price.UIUnitPrice}}</span>
                <span *ngIf="p.ProductReceptionInfo.Price.Discount != null && p.ProductReceptionInfo.Price.Discount.Value != null">{{p.ProductReceptionInfo.Price.UIUnitPriceDiscount}}</span>
                <p matTooltip="{{p.ProductReceptionInfo.ExpectedPOProductInfo.Status.Description}}" matTooltipClass='neutral-tool-tip-management' class="ExpectedPOPrice" *ngIf="p.ProductReceptionInfo.ExpectedPOProductInfo?.Price > 0;"  [ngClass]="{'PriceDifference': p.ProductReceptionInfo.ExpectedPOProductInfo.Status.ID == -1, 'ExpectedPrice': p.ProductReceptionInfo.ExpectedPOProductInfo.Status.ID == 1}">
                  [{{p.ProductReceptionInfo.ExpectedPOProductInfo.Price}} {{p.ProductReceptionInfo.ExpectedPOProductInfo.CurrencyName}}]
                </p>
                <p matTooltip="{{p.ProductReceptionInfo.ExpectedPOProductInfo.Status.Description}}" matTooltipClass='neutral-tool-tip-management'  class="ExpectedPOPrice" *ngIf="p.ProductReceptionInfo.ExpectedPOProductInfo?.Price == 0;"  [ngClass]="{'PriceNotFound': p.ProductReceptionInfo.ExpectedPOProductInfo.Status.ID == 0}">
                  [{{p.ProductReceptionInfo.ExpectedPOProductInfo.Status.Name}}]
                </p>
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;">
                <span *ngIf="p.ProductReceptionInfo.Price.Discount == null || p.ProductReceptionInfo.Price.Discount.Value == null">{{p.ProductReceptionInfo.Price.UIQtyPrice}}</span>
                <span *ngIf="p.ProductReceptionInfo.Price.Discount != null && p.ProductReceptionInfo.Price.Discount.Value != null">{{p.ProductReceptionInfo.Price.UIQtyPriceDiscount}}</span>
              </div>
              <div class="ReceptionProductsCol" style="width: 7.5%;">
                <span>{{p.ProductReceptionInfo.Price.TotalVATValue}}</span>
              </div>
              <div class="ReceptionProductsCol" style="width: 7.5%;">
                <i class="material-icons ReceptionProductEdit" *ngIf="p.ProductReceptionInfo.GeneralType.ID != 1;" (click)="OpenProductTaxDivision(p.ProductReceptionInfo.UIID);">calculate</i>
                <i class="material-icons ReceptionProductEdit" (click)="OpenReceptionEditProduct(p.ProductReceptionInfo.UIID);CurrentIndexProduct = i;">edit</i>
                <div class="ReceptionProductEdit" (click)="OpenProductDiscountContainer(p);" *ngIf="CurrentReception.Total.Discount != undefined && CurrentReception.Total.Discount.Value == null;">%</div>
                <i class="material-icons ReceptionProductEdit" style="color: red;" (click)="DeleteAuxProduct(p.ProductReceptionInfo.UIID);TestDocumentValidity();">close</i>
              </div>
              
              <div style="margin-left: 0%;margin-right: unset;float: left;background: #ddf4b9;cursor: pointer;" class="ProductDiscountRow" *ngIf="p.ProductReceptionInfo.GeneralType.ID != 1 && p.ProductReceptionInfo.GeneralType.IsTaxConsumed == true;" (click)="OpenProductTaxDivision(p.ProductReceptionInfo.UIID);">
                <p>
                  {{ 'Receptions.Consumed' | translate }}
                </p>
                <p>
                  ({{p.ProductReceptionInfo.GeneralType.TaxDivisionType.Name}})
                </p>
              </div>

              <div class="ProductDiscountRow" *ngIf="p.ProductReceptionInfo.Price.Discount != null && p.ProductReceptionInfo.Price.Discount.Value != null">
                  <p>
                    Discount - {{p.ProductReceptionInfo.Price.Discount.Value}}
                    <span *ngIf="p.ProductReceptionInfo.Price.Discount.Type.ID == 1;">%</span>
                    <span *ngIf="p.ProductReceptionInfo.Price.Discount.Type.ID == 2;">{{currency.Name}}</span>
                  </p>
              </div>
          </div>

          <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngIf="this.Products.length;">
            <div class="ReceptionProductsCol">
               
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
                
            </div>
            <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
              
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
             
            </div>
            <div class="ReceptionProductsCol" style="width: 15%;">
              <mat-form-field style="width: 100%;" appearance="outline">
                <mat-label>{{ 'Receptions.DecimalPercision' | translate }}</mat-label>
                <mat-select name="TotalRowDecimalPrecision" [compareWith]="compareFn" [(ngModel)]="TotalRowDecimalPrecision">
                  <mat-option *ngFor="let p of this.DecimalPrecisions" [value]="p" (onSelectionChange)="chanveNewProductVALUE($event);" (click)="GetReceptionTotalValues();">
                    {{p.Meaning}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
              Total:
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
              {{this.CurrentReception.Total.TotalQtyPriceNOVAT}}
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              {{this.CurrentReception.Total.TotalVAT}}
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              {{this.CurrentReception.Total.TotalQtyPriceVAT}}
            </div>
        </div>

        <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngIf="this.Products.length;">
          <div class="ReceptionProductsCol">
             
          </div>
          <div class="ReceptionProductsCol" style="width: 10%;">
            <button mat-button color="warn" (click)="EliminateDocumentDiscount();" *ngIf="CurrentReception.Total.Discount != null && CurrentReception.Total.Discount.Value != null">
              <i class="material-icons buttonIcon">close</i>
              {{ 'Receptions.EliminateDiscount' | translate }}
             </button>
          </div>
          <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
            
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
            
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
           
          </div>
          <div class="ReceptionProductsCol" style="width: 15%;">
            
          </div>
          <div class="ReceptionProductsCol" style="width: 10%;">
            <div class="ProductGeneralDiscountRow" *ngIf="CurrentReception.Total.Discount != null && CurrentReception.Total.Discount.Value != null">
              <p style="padding-top: 0px;line-height: 35px;overflow: hidden;">
                Discount - {{CurrentReception.Total.Discount.Value}}
                <span *ngIf="CurrentReception.Total.Discount.Type.ID == 1;">%</span>
                <span *ngIf="CurrentReception.Total.Discount.Type.ID == 2;">{{currency.Name}}</span>
              </p>
          </div>
          </div>
          <div class="ReceptionProductsCol" style="width: 25%;text-align: right;padding-right: 10px;">
            <button mat-button color="primary" (click)="OpenDocumentDiscountContainer();">{{ 'Receptions.DocDiscount' | translate }} %</button>
          </div>
      </div>

        </div>

        <div class="ReceptionBottomCommands">
          <div class="BottomCommandsOverlay" *ngIf="!ValidDocument;"></div>
          <div class="PopUpBodyRowContainer">
            <div class="PopUpBodyOneThirddContainer">
              <div class="PopUpBodyRowContainer">
                <mat-form-field appearance="outline" class="txtAreaReception">
                  <mat-label>{{ 'Receptions.Mentions' | translate }}</mat-label>
                  <textarea matInput cdkTextareaAutosize [(ngModel)]="CurrentReception.Details.Observations"></textarea>
                </mat-form-field>
              </div>

              <div class="PopUpBodyRowContainer">
                <mat-form-field appearance="outline" class="txtAreaReception">
                  <mat-label>{{ 'Receptions.InternalCommentary' | translate }}</mat-label>
                  <textarea matInput cdkTextareaAutosize [(ngModel)]="CurrentReception.Details.InternalCommentary"></textarea>
                </mat-form-field>
              </div>
            </div>
            <div class="PopUpBodyOneThirddContainer">
              <div class="PopUpBodyRowContainer">
                <mat-form-field appearance="outline" class="txtAreaReception">
                  <mat-label>{{ 'Receptions.ReceptionComittee' | translate }}</mat-label>
                  <textarea matInput cdkTextareaAutosize [(ngModel)]="CurrentReception.Details.ReceptionCommittee"></textarea>
                </mat-form-field>
              </div>
            </div>
            <div class="PopUpBodyOneThirddContainer">
              <div class="PopUpBodyRowContainer">
                <mat-form-field appearance="outline" class="txtAreaReception">
                  <mat-label>{{ 'Receptions.Delegate' | translate }}</mat-label>
                  <textarea matInput cdkTextareaAutosize [(ngModel)]="CurrentReception.Details.Delegate"></textarea>
                </mat-form-field>
              </div>

              <div class="PopUpBodyRowContainer">
                <mat-form-field appearance="outline" class="txtAreaReception">
                  <mat-label>{{ 'Receptions.Auto' | translate }}</mat-label>
                  <textarea matInput cdkTextareaAutosize [(ngModel)]="CurrentReception.Details.Auto"></textarea>
                </mat-form-field>
              </div>
              <div class="PopUpBodyRowContainer" *ngIf="CurrentReception.ID != null;">
                <form [formGroup]="newBlogForm" style="width: auto;float: left;">
                  <div style="margin-bottom: 10px;">
                      <input mat-raised-button type="file" formControlName="UploadedFile" (change)="onSelectFile($event)" style="width: 80%;">
                  </div>
                </form>
              </div>
              <div class="PopUpBodyRowContainer" *ngIf="selectedFile != null;">
                <button mat-raised-button color="accent" (click)="UploadReceptionFile();">
                  <i class="material-icons">upload_file</i>
                  {{'UploadFile' | translate}}
                </button>
              </div>
              <div class="PopUpBodyRowContainer" *ngIf="CurrentReception.ID != null && CurrentReception.FilePath != null;">
                <button mat-button color="primary" (click)="DownloadFile(CurrentReception);">
                  <i class="material-icons">download</i>
                  {{'DownloadFile' | translate}}
                </button>
              </div>
              <div class="PopUpBodyRowContainer" *ngIf="CurrentReception.ID != null && CurrentReception.FilePath != null;">
                <button mat-button color="warn" (click)="OpenDeleteFileQuestion();">
                  <i class="material-icons">delete_forever</i>
                  {{'DeleteFile' | translate}}
                </button>
              </div>

              <div class="PopUpBodyRowContainer">
                <button mat-raised-button color="primary" (click)="InitializeNewPayment();" *ngIf="this.CurrentReception.ID != null;">
                  {{'NewPayment' | translate}}
                  <i class="material-icons">payment</i>
                </button>
                <button mat-raised-button color="primary" (click)="InitializeNewPaymentOnNewReception();" *ngIf="this.CurrentReception.ID == null;">
                  {{'NewPayment' | translate}}
                  <i class="material-icons">payment</i>
                </button>
              </div>

              <div class="PopUpBodyRowContainer" *ngIf="CurrentReception.ID != null || this.CurrentReception?.Details?.Payments?.length > 0;">
                <button mat-raised-button color="primary" (click)="OpenPayments();">
                  {{'Payments' | translate}}
                  <i class="material-icons">payments</i>
                </button>
              </div>

              <div class="PopUpBodyRowContainer" style="margin-top: 5px;">
                <button mat-raised-button (click)="GetShippingDetails(this.CurrentReception.Details.ID, this.CurrentReception.Supplier.ID);">
                  <i class="material-icons">local_shipping</i>
                  {{'ShippingDetails' | translate}}
                </button>
              </div>

              <div class="PopUpBodyRowContainer" style="margin-top: 5px;">
                <mat-slide-toggle (change)="ChangePaymentApprovalStatus();" [(ngModel)]="this.CurrentReception.Details.PaymentApprovalStatus.Approved" style="margin-top: 14px;" matTooltip="{{'PaymentApprovalStatusDesc' | translate}}" matTooltipClass='neutral-tool-tip'>{{this.CurrentReception.Details.PaymentApprovalStatus?.Name}}</mat-slide-toggle>
              </div>

              <div class="PopUpBodyRowContainer" style="margin-top: 5px;">
                <mat-slide-toggle [(ngModel)]="this.CurrentReception.Details.ForceDocumentClosing" style="margin-top: 14px;" matTooltip="{{'ForceDocumentClosingDesc' | translate}}" matTooltipClass='neutral-tool-tip'>{{'ForceDocumentClosing' | translate}}</mat-slide-toggle>
              </div>
            </div>
          </div>
          <div class="PopUpBodyRowContainer">
            <button mat-raised-button color="primary" class="SaveReceptionButton" (click)="AddReception();" *ngIf="CurrentReception.ID == null;">
               <span *ngIf="!IsStorno;">{{ 'Receptions.SaveReception' | translate }}</span>
               <span *ngIf="IsStorno;">{{ 'Receptions.StornoReception' | translate }}</span>
               <i class="material-icons">save_alt</i>
            </button>

            <button mat-raised-button color="primary" class="SaveReceptionButton" (click)="UpdateReception();" *ngIf="CurrentReception.ID != null;">
              <span *ngIf="!IsStorno;">{{ 'Receptions.UpdateReception' | translate }}</span>
              <span *ngIf="IsStorno;">{{ 'Receptions.ModifyStorno' | translate }}</span>
              <i class="material-icons">save_alt</i>
           </button>
          </div>
        </div>
    </div>
</div>